<template>
  <div class="view-tasklists">
    <user-menu />
    <div class="wrapper">
      <masteradmin-sidebar-menu />
        <div id="top" class="content-wrapper">
        <div class="container-wrapper center">
          <div class="modal-custom" v-show="showOverlay">
            <div class="loader-img-center">
              <i class="fa fa-spinner fa-spin"></i> Please wait...
            </div>
          </div>
          <div>
            <div class="col-lg-10 float-left override-padding">
              <h3 class="d-inline heading">Assessment Sections</h3>
            </div>
            <div v-if="assessment_section_lists.length > 0 && loading == false" class="col-lg-2 float-left override-padding">
              <button
                      v-on:click="scrollTo('Bottom')"
                      class="btn btn-white col-12 override-padding" style="margin-top: 2px; height: 30px; border-radius: 10px; font-weight: bold;"
                      >Jump to Bottom <i class="cursor-pointer fa fa-angle-down" style="font-size: 21px; color: #333; padding-left: 5px; vertical-align: bottom;"></i></button>
            </div>
            <div style="clear: both"></div>
          </div>
          <div class="heading-seperator"></div>
          <div class="margin-bottom-10"></div>

          <div class="">
            <b-navbar toggleable="lg" type="light" variant="light">
              <b-navbar-brand href="#">Filter/Search</b-navbar-brand>

              <b-navbar-toggle target="nav-collapse"><i class="fa fa-chevron-down	"></i></b-navbar-toggle>


              <b-collapse id="nav-collapse" is-nav>
          <div class="search-wrapper col-12">
          <div class="row col-12 override-padding">
            <div
              class="col-lg-3 col-md-12 col-12 padding-lr-5"
              style="padding-left: 0; padding-right: 0;"
              >
            <b-form-input
              class="input-text"
              v-model="search_keyword"
              type="text"
              placeholder="Search by Assessment Section Title"
              @keyup.enter="filterAssessmentSectionitems()"
              maxlength="255"
            ></b-form-input>
            </div>
            <div class="col-lg-2 col-md-12 col-12 padding-lr-5" style="padding-right: 0;">
               <b-form-select
                class="input-text"
                v-model="search_scale"
                :options="scale_options"
                @change="filterAssessmentSectionitems()"
               >
              </b-form-select>
            </div>
            <div class="col-lg-2 col-md-12 col-12 padding-lr-5" style="margin-top: 2px;">
                <date-picker
                  v-model="search_date"
                  format="MM/DD/YYYY"
                  placeholder="Date"
                  v-bind:clearable="false"
                  input-class="col-md-12 input-height-30 padding-lr-5"
                  >
                  <template v-slot:icon-calendar>
                    <i class="fa fa-calendar red-color" aria-hidden="true"></i>
                  </template>
                </date-picker>
            </div>
            <div class="col-lg-1 col-md-12 col-12 padding-lr-5" style="padding-left: 0; padding-right: 0;">
               <b-form-select
                class="input-text"
                v-model="search_status"
                :options="status_options"
                @change="filterAssessmentSectionitems()"
               >
              </b-form-select>
            </div>
            <div class="col-lg-2 col-md-12 col-12 padding-lr-5">
               <b-form-select
                class="input-text"
                v-model="search_user"
                :options="user_options"
                @change="filterAssessmentSectionitems()"
               >
              </b-form-select>
            </div>
            <div class="col-lg-1 col-md-4 col-4 padding-lr-5">
              <button
                @click="filterAssessmentSectionitems()"
                class="btn btn-red col-12 padding-lr-5"
                style="height: 32px;border-radius: 10px; margin-top: 2px;font-weight: bold;">Search</button>
            </div>
            <div class="col-lg-1 col-md-4 col-4 padding-lr-5">
              <button
                v-on:click="isModalVisible = true, verrors.clear()"
                class="btn btn-white col-12 override-padding" style="margin-top: 2px; height: 32px; border-radius: 10px; font-weight: bold;"
                >New Section</button>
            </div>
          </div>
          </div> 
          </b-collapse>
        </b-navbar>
      </div>
          <div class="margin-bottom-10"></div>
                <div v-if="rows > 1" class="overflow-auto float-right pagination-wrapper" style="margin: 0;">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                    v-bind:hide-goto-end-buttons=true
                    @input="showTasklistofPaginated()"
                    ></b-pagination>
                </div>
                <div style="clear: both;"></div>
          <div>
            <div v-show="verrors.has('sections')" class="validate-warning-msg">{{ verrors.first('sections') }}</div>
                 <div class="row tasks_heading_row">
                   <div
                     class="bold cursor-pointer col-3"
                     v-on:click="sortMethod('title')"
                     >
                     Assessment Section Title
                     <i v-if="sortField == 'title' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                     <i v-if="sortField == 'title' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                   </div>
                   <div
                     class="bold cursor-pointer col-2 override-padding"
                     v-on:click="sortMethod('scale')"
                     >
                     Scale
                     <i v-if="sortField == 'scale' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                     <i v-if="sortField == 'scale' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                   </div>
                   <div
                     class="bold col-1 override-padding text-align-center"
                     >
                     # of S/Q's
                     
                   </div>
                   <div
                     class="bold cursor-pointer col-1 override-padding"
                     v-on:click="sortMethod('createdAt')"
                     >
                     Date Created
                     <i v-if="sortField == 'createdAt' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                     <i v-if="sortField == 'createdAt' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                   </div>
                   <div
                     class="bold cursor-pointer col-1 override-padding"
                     v-on:click="sortMethod('updatedBy')"
                     >
                     Last Updated By
                     <i v-if="sortField == 'updatedBy' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                     <i v-if="sortField == 'updatedBy' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                   </div>
                   <div
                     class="bold cursor-pointer col-1 override-padding"
                     v-on:click="sortMethod('updatedAt')"
                     >
                     Last Updated
                     <i v-if="sortField == 'updatedAt' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                     <i v-if="sortField == 'updatedAt' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                   </div>
                   <div
                     class="bold cursor-pointer col-1 override-padding"
                     v-on:click="sortMethod('status')"
                     >
                     Status
                     <i v-if="sortField == 'status' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                     <i v-if="sortField == 'status' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                   </div>
                   <div
                     class="bold cursor-pointer col-1 override-padding"
                     v-on:click="sortMethod('createdBy')"
                     >
                     Created By
                     <i v-if="sortField == 'createdBy' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                     <i v-if="sortField == 'createdBy' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                   </div>
                   <div
                     class="bold col-1 override-padding text-align-right" style="padding-right: 20px;"
                     >
                     Options
                   </div>
                 </div>


                 <!-- No Assessments Text -->
                 <div v-if="assessment_section_lists.length == 0 && loading == false" style="background-color: #FFF; min-height: 480px; padding-top: 180px;" class="col-12 text-align-center">
                  <div class="col-12 text-align-center no-assessment-text">No assessment sections created</div>
                  <button
                    v-on:click="isModalVisible = true, verrors.clear()"
                    class="btn btn-white col-2 override-padding" style="margin-top: 10px; height: 35px; border-radius: 10px;font-weight: bold;"
                    >New Section</button>
 
                 </div>
                <div v-show="loading" class="loading_show">
                  <div class="spinner-border text-danger"></div>
                </div>
                <div class="card-text" v-if="assessment_section_lists.length > 0">
                <div class="tasklists-row" v-for="(list, index) in assessment_section_lists">

                  <div class="row tasklist-item" style="margin: 0;">
                    <div
                      class="col-3"
                      >
                      <span v-if="checkboxVisible == 0">
                        <input v-if="(list.status == 'PUBLISH' && assessment_id > 0 && isEditModalVisible == false && isModalVisible == false)" :value="list.id" type="checkbox" name="sections" :id="list.id" v-model="sections_selected" v-validate data-vv-rules="required" data-vv-as="Sections">
                      </span>
                      <span v-else>
                        <input v-if="(list.status == 'PUBLISH' && assessment_id > 0)" :value="list.id" type="checkbox" name="sections" :id="list.id" v-model="sections_selected">
                      </span>
                      {{list.title}}
                    </div>
                    <div class="col-2 override-padding ">{{getScale(list.scale)}}</div>
                    <div class="col-1 override-padding text-align-center">{{list.statement_count}}</div>
                    <div class="col-1 override-padding">{{FollowDate(list.createdAt)}}</div>
                    <div class="col-1 override-padding">{{ truncate(list.updated_by) }}</div>
                    <div class="col-1 override-padding">{{FollowDate(list.updatedAt)}}</div>
                    <div class="col-1 override-padding">{{ getStatus(list.status) }}</div>
                    <div class="col-1 override-padding">{{ truncate(list.created_by) }}</div>
                    <div class="col-1 override-padding">
                      <div v-bind:id="'dropdown-container'+ index" class="dropdown" @click="toggleDropdown('actionDropdown'+index+'')" >
                        <ul class="dropbtn icons btn-right showLeft"  v-bind:id="'dotted-menu' + index" v-if="list.status != 'DEACTIVATED'">
                          <li></li>
                          <li></li>
                          <li></li>
                        </ul>
                        <div v-bind:id="'actionDropdown' + index" class="dropdown-content">
                          <div class="action-dd-menu" href=""
                          @click="editSectionMethod(list.id)"  ><i class="cursor-pointer fa fa-edit  spacer-icon"></i>Edit</div>
                          <div class="action-dd-menu" href="" v-if="list.status=='DRAFT'" @click="updateSectionStatus(list.id, 'PUBLISH')"><i class="cursor-pointer fa fa-upload spacer-icon"></i>Publish</div>
                          <div class="action-dd-menu" href="" v-if="list.status=='DRAFT'" @click="deleteSectionConfirm(list.id)"><i class="cursor-pointer fa fa-times spacer-icon"></i>Remove</div>
                          <div class="action-dd-menu" href="" v-if="list.status=='PUBLISH'" @click="deactivateSectionConfirm(list.id)"><i class="cursor-pointer fa fa-eye-slash spacer-icon"></i>Deactivate</div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div><hr></div>
                </div>
                <div v-if="rows > 25" class="overflow-auto float-right pagination-wrapper" style="margin-bottom: 0;">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                    v-bind:hide-goto-end-buttons=true
                    @input="showTasklistofPaginated()"
                    ></b-pagination>
                </div>
                <div style="clear: both;"></div>
                </div>

          <div v-if="assessment_section_lists.length > 0 && loading == false" style="margin-top: 20px; margin-bottom: 30px;">
            <div class="col-lg-10 float-left override-padding">
              &nbsp;
            </div>
            <div class="col-lg-2 float-left override-padding">
              <button
                      v-on:click="scrollTo('Top')"
                      class="btn btn-white col-12 override-padding" style="margin-top: 2px; height: 30px; border-radius: 10px; font-weight: bold;"
                      >Jump to Top <i class="cursor-pointer fa fa-angle-up" style="font-size: 21px; color: #333; padding-left: 5px; vertical-align: bottom;"></i></button>
            </div>
            <div style="clear: both"></div>
          </div>

         </div>
        <div class="col-12 override-padding text-align-left" v-if="assessment_id > 0" style="margin-top: 10px; margin-bottom: 25px;">
          <button
              v-on:click="onSubmit()"
              class="btn btn-red col-2 padding-lr-5"
              style="line-height: 25px; border-radius: 10px;"
              ><b>Continue</b></button>
        </div>
      </div>


      </div>
    </div>
    <CreateAssessmentSectionModal :isModalVisible="isModalVisible" @close="isModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading"><h3>Create Assessment Section</h3></div>
      <div slot="body" v-if="isModalVisible === true">
        <div class="col-8 override-padding">
          <div class="col-lg-4 float-left padding-lr-5" style="padding-left: 0;">
          <input v-model="assessment_section_title"
            name="assessment_section_title"
            placeholder="Enter Section Title..."
            class="col-lg-12 padding-lr-5 input-text form-control"
            v-validate="'required'"
            style="line-height: 30px; margin-right: 10px;"
            maxlength="255" />
            <div v-if="verrors.firstByRule('assessment_section_title', 'required')" class="margin-bottom-5 validate-warning-msg">Assessment Section Title is required</div>
          </div>
          <div class="col-lg-3 float-left padding-lr-5">
           <b-form-select
            class="input-text col-lg-12 padding-lr-5"
            v-model="scale"
            name="scale"
            v-validate="'required'"
            :options="scale_options"
           >
          </b-form-select>
          <div v-if="verrors.firstByRule('scale', 'required')" class="margin-bottom-5 validate-warning-msg">Scale is required</div>
          </div>
          <div class="col-lg-3 float-left padding-lr-5">
           <b-form-select
            class="input-text col-lg-12 padding-lr-5"
            v-model="section_type"
            name="section_type"
            v-validate="'required'"
            :options="section_type_options"
            @change="sectionRangeDisplay()"
           >
          </b-form-select>
          <div v-if="verrors.firstByRule('section_type', 'required')" class="margin-bottom-5 validate-warning-msg">Type is required</div>
          </div>
        </div>
         
        <div style="clear:both;margin-bottom: 10px;"></div>
        <div class="col-11 override-padding">
          <div class="add-statement-heading">
            Add Statements/Questions
          </div>
        </div>
        <div class="col-11 override-padding">
          <div class="heading-row">
            <div class="col-1 float-left">#</div>
            <div class="col-2 float-left padding-lr-5" v-if="section_range_display == true">Group</div>
            <div class="col-2 float-left padding-lr-5">Type</div>
            <div class="col-7 float-left padding-lr-5">Statement/Question Text</div>
          </div>
        </div>
        <div class="col-11 override-padding float-left" style="margin-top: 10px;">
          <div class="statement-row col-12 override-padding float-left" v-for="(list, sindex in statement_questions" :key="sindex" style="margin-bottom: 5px;">
            <div class="col-1 float-left" style="font-weight: bold; margin-top: 5px;">{{ sindex + 1}}</div>
            <div class="col-2 float-left padding-lr-5" v-if="section_range_display == true">
             <b-form-select
              class="input-text col-lg-12 float-left padding-lr-5"
              v-model="list.group"
              :ref="'group_' + sindex"
              :options="group_options"
             >
             </b-form-select>
            </div>
            <div class="col-2 float-left padding-lr-5">
             <b-form-select
              class="input-text col-lg-12 float-left padding-lr-5"
              v-model="list.type"
              :ref="'type_' + sindex"
              :options="type_options"
             >
             </b-form-select>
            </div>
            <div class="col-7 float-left padding-lr-5" style="padding-right: 0">
              <input v-model="list.text"
                placeholder="Enter Statement/Question"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                :ref="'text_' + sindex"
                maxlength="255" />
            </div>
          </div>
        </div>
        <div style="clear:both; margin-bottom: 5px;"></div>
        <div class="col-11 override-padding">
          <div class="col-5 override-padding float-left">
            &nbsp;
          </div>
          <div class="col-7 padding-lr-5 float-left add-on" v-on:click="addMoreQuestions()">
            <i class="fa fa-plus spacer-icon" aria-hidden="true"></i> Add Statement/Question (100 Max)
          </div>
        </div>
        <div style="clear:both;margin-bottom: 10px;"></div>
        <div class="col-11 override-padding" v-if="section_range_display == true">
          <div class="add-statement-heading">
            Enter Output Ranges and Text
          </div>
        </div>
        <div class="col-11 overridepadding collapse-wrapper" v-show="checkVisible('A')">
          <b-link v-b-toggle="'collapse-A'" >
            <div>
              Group A
              <i class="fa fa-angle-up" aria-hidden="true"></i>
            </div>
          </b-link>
        </div>
        <b-collapse v-bind:id="'collapse-A'" class="mt-2" visible v-show="checkVisible('A')">

        <div class="col-11 override-padding">
          <div class="heading-row">
            <div class="col-1 float-left padding-lr-5">From</div>
            <div class="col-1 float-left padding-lr-5 text-align-center">>/<</div>
            <div class="col-1 float-left padding-lr-5">To</div>
            <div class="col-9 float-left padding-lr-5">Output Text</div>
          </div>
        </div>
        <div class="col-11 override-padding float-left" style="margin-top: 10px;">
          <div class="statement-row col-12 override-padding float-left" style="margin-bottom: 5px;" v-for="(list, aindex) in group_a_range" :key="aindex">
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.from"
                v-on:blur="checkRangeNumbers(aindex, 'From', 'A')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-1 float-left padding-lr-5 text-align-center" style="margin-top: 5px;">
              -
            </div>
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.to"
                v-on:blur="checkRangeNumbers(aindex, 'To', 'A')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-9 float-left padding-lr-5" style="padding-right: 0;">
              <vue-editor v-model="list.text" :editorToolbar="customToolbar"></vue-editor>
            </div>
          </div>
        </div>
        <div style="clear:both; margin-bottom: 5px;"></div>
        <div class="col-11 override-padding">
          <div class="col-3 override-padding float-left">
            &nbsp;
          </div>
          <div class="col-9 padding-lr-5 float-left add-on" v-on:click="addMoreOutputText('A')">
            <i class="fa fa-plus spacer-icon" aria-hidden="true"></i> <span style="font-style: italic">Add Score Range (25 Max) </span>
          </div>
        </div>
        </b-collapse>
        <div style="clear:both;margin-bottom: 10px;"></div>

        <div class="col-11 overridepadding collapse-wrapper" v-show="checkVisible('B')">
          <b-link v-b-toggle="'collapse-B'">
            <div>
              Group B
              <i class="fa fa-angle-up" aria-hidden="true"></i>
            </div>
          </b-link>
        </div>
        <b-collapse v-bind:id="'collapse-B'" class="mt-2" visible v-show="checkVisible('B')">

        <div class="col-11 override-padding">
          <div class="heading-row">
            <div class="col-1 float-left padding-lr-5">From</div>
            <div class="col-1 float-left padding-lr-5 text-align-center">>/<</div>
            <div class="col-1 float-left padding-lr-5">To</div>
            <div class="col-9 float-left padding-lr-5">Output Text</div>
          </div>
        </div>
        <div class="col-11 override-padding float-left" style="margin-top: 10px;">
          <div class="statement-row col-12 override-padding float-left" style="margin-bottom: 5px;"  v-for="(list, bindex) in group_b_range" :key="bindex">
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.from"
                v-on:blur="checkRangeNumbers(bindex, 'From', 'B')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-1 float-left padding-lr-5 text-align-center" style="margin-top: 5px;">
              -
            </div>
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.to"
                v-on:blur="checkRangeNumbers(bindex, 'To', 'B')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-9 float-left padding-lr-5" style="padding-right: 0;">
              <vue-editor v-model="list.text" :editorToolbar="customToolbar"></vue-editor>
            </div>
          </div>
        </div>
        <div style="clear:both; margin-bottom: 5px;"></div>
        <div class="col-11 override-padding">
          <div class="col-3 override-padding float-left">
            &nbsp;
          </div>
          <div class="col-9 padding-lr-5 float-left add-on" v-on:click="addMoreOutputText('B')">
            <i class="fa fa-plus spacer-icon" aria-hidden="true"></i> <span style="font-style: italic">Add Score Range (25 Max) </span>
          </div>
        </div>
        </b-collapse>

        <div style="clear:both;margin-bottom: 10px;"></div>

        <div class="col-11 overridepadding collapse-wrapper" v-show="checkVisible('C')">
          <b-link v-b-toggle="'collapse-C'" >
            <div>
              Group C
              <i class="fa fa-angle-up" aria-hidden="true"></i>
            </div>
          </b-link>
        </div>
        <b-collapse v-bind:id="'collapse-C'" class="mt-2" visible v-show="checkVisible('C')">

        <div class="col-11 override-padding">
          <div class="heading-row">
            <div class="col-1 float-left padding-lr-5">From</div>
            <div class="col-1 float-left padding-lr-5 text-align-center">>/<</div>
            <div class="col-1 float-left padding-lr-5">To</div>
            <div class="col-9 float-left padding-lr-5">Output Text</div>
          </div>
        </div>
        <div class="col-11 override-padding float-left" style="margin-top: 10px;">
          <div class="statement-row col-12 override-padding float-left" style="margin-bottom: 5px;" v-for="(list, aindex) in group_c_range" :key="aindex">
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.from"
                v-on:blur="checkRangeNumbers(aindex, 'From', 'C')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-1 float-left padding-lr-5 text-align-center" style="margin-top: 5px;">
              -
            </div>
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.to"
                v-on:blur="checkRangeNumbers(aindex, 'To', 'C')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-9 float-left padding-lr-5" style="padding-right: 0;">
              <vue-editor v-model="list.text" :editorToolbar="customToolbar"></vue-editor>
            </div>
          </div>
        </div>
        <div style="clear:both; margin-bottom: 5px;"></div>
        <div class="col-11 override-padding">
          <div class="col-3 override-padding float-left">
            &nbsp;
          </div>
          <div class="col-9 padding-lr-5 float-left add-on" v-on:click="addMoreOutputText('C')">
            <i class="fa fa-plus spacer-icon" aria-hidden="true"></i> <span style="font-style: italic">Add Score Range (25 Max) </span>
          </div>
        </div>
        </b-collapse>
        <div style="clear:both;margin-bottom: 10px;"></div>

        <div class="col-11 overridepadding collapse-wrapper" v-show="checkVisible('D')">
          <b-link v-b-toggle="'collapse-D'" >
            <div>
              Group D
              <i class="fa fa-angle-up" aria-hidden="true"></i>
            </div>
          </b-link>
        </div>
        <b-collapse v-bind:id="'collapse-D'" class="mt-2" visible v-show="checkVisible('D')">

        <div class="col-11 override-padding">
          <div class="heading-row">
            <div class="col-1 float-left padding-lr-5">From</div>
            <div class="col-1 float-left padding-lr-5 text-align-center">>/<</div>
            <div class="col-1 float-left padding-lr-5">To</div>
            <div class="col-9 float-left padding-lr-5">Output Text</div>
          </div>
        </div>
        <div class="col-11 override-padding float-left" style="margin-top: 10px;">
          <div class="statement-row col-12 override-padding float-left" style="margin-bottom: 5px;" v-for="(list, aindex) in group_d_range" :key="aindex">
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.from"
                v-on:blur="checkRangeNumbers(aindex, 'From', 'D')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-1 float-left padding-lr-5 text-align-center" style="margin-top: 5px;">
              -
            </div>
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.to"
                v-on:blur="checkRangeNumbers(aindex, 'To', 'D')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-9 float-left padding-lr-5" style="padding-right: 0;">
              <vue-editor v-model="list.text" :editorToolbar="customToolbar"></vue-editor>
            </div>
          </div>
        </div>
        <div style="clear:both; margin-bottom: 5px;"></div>
        <div class="col-11 override-padding">
          <div class="col-3 override-padding float-left">
            &nbsp;
          </div>
          <div class="col-9 padding-lr-5 float-left add-on" v-on:click="addMoreOutputText('D')">
            <i class="fa fa-plus spacer-icon" aria-hidden="true"></i> <span style="font-style: italic">Add Score Range (25 Max) </span>
          </div>
        </div>
        </b-collapse>
        <div style="clear:both;margin-bottom: 10px;"></div>
        <div class="col-11 overridepadding collapse-wrapper" v-show="checkVisible('E')">
          <b-link v-b-toggle="'collapse-E'" >
            <div>
              Group E
              <i class="fa fa-angle-up" aria-hidden="true"></i>
            </div>
          </b-link>
        </div>
        <b-collapse v-bind:id="'collapse-E'" class="mt-2" visible v-show="checkVisible('E')">

        <div class="col-11 override-padding">
          <div class="heading-row">
            <div class="col-1 float-left padding-lr-5">From</div>
            <div class="col-1 float-left padding-lr-5 text-align-center">>/<</div>
            <div class="col-1 float-left padding-lr-5">To</div>
            <div class="col-9 float-left padding-lr-5">Output Text</div>
          </div>
        </div>
        <div class="col-11 override-padding float-left" style="margin-top: 10px;">
          <div class="statement-row col-12 override-padding float-left" style="margin-bottom: 5px;" v-for="(list, aindex) in group_e_range" :key="aindex">
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.from"
                v-on:blur="checkRangeNumbers(aindex, 'From', 'E')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-1 float-left padding-lr-5 text-align-center" style="margin-top: 5px;">
              -
            </div>
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.to"
                v-on:blur="checkRangeNumbers(aindex, 'To', 'E')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-9 float-left padding-lr-5" style="padding-right: 0;">
              <vue-editor v-model="list.text" :editorToolbar="customToolbar"></vue-editor>
            </div>
          </div>
        </div>
        <div style="clear:both; margin-bottom: 5px;"></div>
        <div class="col-11 override-padding">
          <div class="col-3 override-padding float-left">
            &nbsp;
          </div>
          <div class="col-9 padding-lr-5 float-left add-on" v-on:click="addMoreOutputText('E')">
            <i class="fa fa-plus spacer-icon" aria-hidden="true"></i> <span style="font-style: italic">Add Score Range (25 Max) </span>
          </div>
        </div>
        </b-collapse>
        <div style="clear:both;margin-bottom: 10px;"></div>
        <div class="col-11 overridepadding collapse-wrapper" v-show="checkVisible('F')">
          <b-link v-b-toggle="'collapse-F'" >
            <div>
              Group F
              <i class="fa fa-angle-up" aria-hidden="true"></i>
            </div>
          </b-link>
        </div>
        <b-collapse v-bind:id="'collapse-F'" class="mt-2" visible v-show="checkVisible('F')">

        <div class="col-11 override-padding">
          <div class="heading-row">
            <div class="col-1 float-left padding-lr-5">From</div>
            <div class="col-1 float-left padding-lr-5 text-align-center">>/<</div>
            <div class="col-1 float-left padding-lr-5">To</div>
            <div class="col-9 float-left padding-lr-5">Output Text</div>
          </div>
        </div>
        <div class="col-11 override-padding float-left" style="margin-top: 10px;">
          <div class="statement-row col-12 override-padding float-left" style="margin-bottom: 5px;" v-for="(list, aindex) in group_f_range" :key="aindex">
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.from"
                v-on:blur="checkRangeNumbers(aindex, 'From', 'F')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-1 float-left padding-lr-5 text-align-center" style="margin-top: 5px;">
              -
            </div>
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.to"
                v-on:blur="checkRangeNumbers(aindex, 'To', 'F')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-9 float-left padding-lr-5" style="padding-right: 0;">
              <vue-editor v-model="list.text" :editorToolbar="customToolbar"></vue-editor>
            </div>
          </div>
        </div>
        <div style="clear:both; margin-bottom: 5px;"></div>
        <div class="col-11 override-padding">
          <div class="col-3 override-padding float-left">
            &nbsp;
          </div>
          <div class="col-9 padding-lr-5 float-left add-on" v-on:click="addMoreOutputText('F')">
            <i class="fa fa-plus spacer-icon" aria-hidden="true"></i> <span style="font-style: italic">Add Score Range (25 Max) </span>
          </div>
        </div>
        </b-collapse>
        <div style="clear:both;margin-bottom: 10px;"></div>
        <div class="col-11 overridepadding collapse-wrapper" v-show="checkVisible('G')">
          <b-link v-b-toggle="'collapse-G'" >
            <div>
              Group G
              <i class="fa fa-angle-up" aria-hidden="true"></i>
            </div>
          </b-link>
        </div>
        <b-collapse v-bind:id="'collapse-G'" class="mt-2" visible v-show="checkVisible('G')">

        <div class="col-11 override-padding">
          <div class="heading-row">
            <div class="col-1 float-left padding-lr-5">From</div>
            <div class="col-1 float-left padding-lr-5 text-align-center">>/<</div>
            <div class="col-1 float-left padding-lr-5">To</div>
            <div class="col-9 float-left padding-lr-5">Output Text</div>
          </div>
        </div>
        <div class="col-11 override-padding float-left" style="margin-top: 10px;">
          <div class="statement-row col-12 override-padding float-left" style="margin-bottom: 5px;" v-for="(list, aindex) in group_g_range" :key="aindex">
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.from"
                v-on:blur="checkRangeNumbers(aindex, 'From', 'G')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-1 float-left padding-lr-5 text-align-center" style="margin-top: 5px;">
              -
            </div>
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.to"
                v-on:blur="checkRangeNumbers(aindex, 'To', 'G')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-9 float-left padding-lr-5" style="padding-right: 0;">
              <vue-editor v-model="list.text" :editorToolbar="customToolbar"></vue-editor>
            </div>
          </div>
        </div>
        <div style="clear:both; margin-bottom: 5px;"></div>
        <div class="col-11 override-padding">
          <div class="col-3 override-padding float-left">
            &nbsp;
          </div>
          <div class="col-9 padding-lr-5 float-left add-on" v-on:click="addMoreOutputText('G')">
            <i class="fa fa-plus spacer-icon" aria-hidden="true"></i> <span style="font-style: italic">Add Score Range (25 Max) </span>
          </div>
        </div>
        </b-collapse>
        <div style="clear:both;margin-bottom: 10px;"></div>
        <div class="col-11 overridepadding collapse-wrapper" v-show="checkVisible('H')">
          <b-link v-b-toggle="'collapse-H'" >
            <div>
              Group H
              <i class="fa fa-angle-up" aria-hidden="true"></i>
            </div>
          </b-link>
        </div>
        <b-collapse v-bind:id="'collapse-H'" class="mt-2" visible v-show="checkVisible('H')">

        <div class="col-11 override-padding">
          <div class="heading-row">
            <div class="col-1 float-left padding-lr-5">From</div>
            <div class="col-1 float-left padding-lr-5 text-align-center">>/<</div>
            <div class="col-1 float-left padding-lr-5">To</div>
            <div class="col-9 float-left padding-lr-5">Output Text</div>
          </div>
        </div>
        <div class="col-11 override-padding float-left" style="margin-top: 10px;">
          <div class="statement-row col-12 override-padding float-left" style="margin-bottom: 5px;" v-for="(list, aindex) in group_h_range" :key="aindex">
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.from"
                v-on:blur="checkRangeNumbers(aindex, 'From', 'H')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-1 float-left padding-lr-5 text-align-center" style="margin-top: 5px;">
              -
            </div>
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.to"
                v-on:blur="checkRangeNumbers(aindex, 'To', 'H')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-9 float-left padding-lr-5" style="padding-right: 0;">
              <vue-editor v-model="list.text" :editorToolbar="customToolbar"></vue-editor>
            </div>
          </div>
        </div>
        <div style="clear:both; margin-bottom: 5px;"></div>
        <div class="col-11 override-padding">
          <div class="col-3 override-padding float-left">
            &nbsp;
          </div>
          <div class="col-9 padding-lr-5 float-left add-on" v-on:click="addMoreOutputText('H')">
            <i class="fa fa-plus spacer-icon" aria-hidden="true"></i> <span style="font-style: italic">Add Score Range (25 Max) </span>
          </div>
        </div>
        </b-collapse>
        <div style="clear:both;margin-bottom: 10px;"></div>
        <div class="col-11 overridepadding collapse-wrapper" v-show="checkVisible('I')">
          <b-link v-b-toggle="'collapse-I'" >
            <div>
              Group I
              <i class="fa fa-angle-up" aria-hidden="true"></i>
            </div>
          </b-link>
        </div>
        <b-collapse v-bind:id="'collapse-I'" class="mt-2" visible v-show="checkVisible('I')">

        <div class="col-11 override-padding">
          <div class="heading-row">
            <div class="col-1 float-left padding-lr-5">From</div>
            <div class="col-1 float-left padding-lr-5 text-align-center">>/<</div>
            <div class="col-1 float-left padding-lr-5">To</div>
            <div class="col-9 float-left padding-lr-5">Output Text</div>
          </div>
        </div>
        <div class="col-11 override-padding float-left" style="margin-top: 10px;">
          <div class="statement-row col-12 override-padding float-left" style="margin-bottom: 5px;" v-for="(list, aindex) in group_i_range" :key="aindex">
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.from"
                v-on:blur="checkRangeNumbers(aindex, 'From', 'I')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-1 float-left padding-lr-5 text-align-center" style="margin-top: 5px;">
              -
            </div>
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.to"
                v-on:blur="checkRangeNumbers(aindex, 'To', 'I')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-9 float-left padding-lr-5" style="padding-right: 0;">
              <vue-editor v-model="list.text" :editorToolbar="customToolbar"></vue-editor>
            </div>
          </div>
        </div>
        <div style="clear:both; margin-bottom: 5px;"></div>
        <div class="col-11 override-padding">
          <div class="col-3 override-padding float-left">
            &nbsp;
          </div>
          <div class="col-9 padding-lr-5 float-left add-on" v-on:click="addMoreOutputText('I')">
            <i class="fa fa-plus spacer-icon" aria-hidden="true"></i> <span style="font-style: italic">Add Score Range (25 Max) </span>
          </div>
        </div>
        </b-collapse>
        <div style="clear:both;margin-bottom: 10px;"></div>
        <div class="col-11 overridepadding collapse-wrapper" v-show="checkVisible('J')">
          <b-link v-b-toggle="'collapse-J'" >
            <div>
              Group J
              <i class="fa fa-angle-up" aria-hidden="true"></i>
            </div>
          </b-link>
        </div>
        <b-collapse v-bind:id="'collapse-J'" class="mt-2" visible v-show="checkVisible('J')">

        <div class="col-11 override-padding">
          <div class="heading-row">
            <div class="col-1 float-left padding-lr-5">From</div>
            <div class="col-1 float-left padding-lr-5 text-align-center">>/<</div>
            <div class="col-1 float-left padding-lr-5">To</div>
            <div class="col-9 float-left padding-lr-5">Output Text</div>
          </div>
        </div>
        <div class="col-11 override-padding float-left" style="margin-top: 10px;">
          <div class="statement-row col-12 override-padding float-left" style="margin-bottom: 5px;" v-for="(list, aindex) in group_j_range" :key="aindex">
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.from"
                v-on:blur="checkRangeNumbers(aindex, 'From', 'J')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-1 float-left padding-lr-5 text-align-center" style="margin-top: 5px;">
              -
            </div>
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.to"
                v-on:blur="checkRangeNumbers(aindex, 'To', 'J')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-9 float-left padding-lr-5" style="padding-right: 0;">
              <vue-editor v-model="list.text" :editorToolbar="customToolbar"></vue-editor>
            </div>
          </div>
        </div>
        <div style="clear:both; margin-bottom: 5px;"></div>
        <div class="col-11 override-padding">
          <div class="col-3 override-padding float-left">
            &nbsp;
          </div>
          <div class="col-9 padding-lr-5 float-left add-on" v-on:click="addMoreOutputText('J')">
            <i class="fa fa-plus spacer-icon" aria-hidden="true"></i> <span style="font-style: italic">Add Score Range (25 Max) </span>
          </div>
        </div>
        </b-collapse>
        <div style="clear:both;margin-bottom: 10px;"></div>
        <div class="col-11 overridepadding collapse-wrapper" v-show="checkVisible('K')">
          <b-link v-b-toggle="'collapse-K'" >
            <div>
              Group K
              <i class="fa fa-angle-up" aria-hidden="true"></i>
            </div>
          </b-link>
        </div>
        <b-collapse v-bind:id="'collapse-K'" class="mt-2" visible v-show="checkVisible('K')">

        <div class="col-11 override-padding">
          <div class="heading-row">
            <div class="col-1 float-left padding-lr-5">From</div>
            <div class="col-1 float-left padding-lr-5 text-align-center">>/<</div>
            <div class="col-1 float-left padding-lr-5">To</div>
            <div class="col-9 float-left padding-lr-5">Output Text</div>
          </div>
        </div>
        <div class="col-11 override-padding float-left" style="margin-top: 10px;">
          <div class="statement-row col-12 override-padding float-left" style="margin-bottom: 5px;" v-for="(list, aindex) in group_k_range" :key="aindex">
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.from"
                v-on:blur="checkRangeNumbers(aindex, 'From', 'K')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-1 float-left padding-lr-5 text-align-center" style="margin-top: 5px;">
              -
            </div>
            <div class="col-1 float-left padding-lr-5">
              <input v-model="list.to"
                v-on:blur="checkRangeNumbers(aindex, 'To', 'K')"
                class="col-lg-12 input-text form-control float-left padding-lr-5"
                style="line-height: 30px;"
                maxlength="5" />
            </div>
            <div class="col-9 float-left padding-lr-5" style="padding-right: 0;">
              <vue-editor v-model="list.text" :editorToolbar="customToolbar"></vue-editor>
            </div>
          </div>
        </div>
        <div style="clear:both; margin-bottom: 5px;"></div>
        <div class="col-11 override-padding">
          <div class="col-3 override-padding float-left">
            &nbsp;
          </div>
          <div class="col-9 padding-lr-5 float-left add-on" v-on:click="addMoreOutputText('K')">
            <i class="fa fa-plus spacer-icon" aria-hidden="true"></i> <span style="font-style: italic">Add Score Range (25 Max) </span>
          </div>
        </div>
        </b-collapse>
        <div style="clear:both;margin-bottom: 10px;"></div>

        <div class="col-11 override-padding">
            <div class="col-lg-2 col-md-4 col-4 padding-lr-5 float-right"  style="padding-right: 0px;">
              <button
                v-on:click="createAssessmentSection('PUBLISH')"
                class="btn btn-red col-12 override-padding" style="margin-top: 2px; height: 32px; border-radius: 10px;"
                >Publish</button>
            </div>
            <div class="col-lg-2 col-md-4 col-4 padding-lr-5 float-right">
              <button
                v-on:click="createAssessmentSection('DRAFT')"
                class="btn btn-white col-12 padding-lr-5"
                style="height: 32px;border-radius: 10px; margin-top: 2px;">Save as Draft</button>
            </div>
        </div>
      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </CreateAssessmentSectionModal>

      <EditAssessmentSectionModal ref="EditModal" :isModalVisible="isEditModalVisible" :sectionId="editSectionId" @close="isEditModalVisible = false">
      </EditAssessmentSectionModal>

    <DeleteModal :isModalVisible="isDeleteModalVisible" :id="id"  @close="isDeleteModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading">Are you sure you want to delete?</div>
      <div slot="body">

      </div>
      <div slot="footer" class="col-3 override-padding">
        <button class="left col-12 btn btn-red" @click="deleteSection(id)">Confirm</button>
      </div>
    </DeleteModal>

    <DeactivateModal :isModalVisible="isDeactivateModalVisible" :id="deactivateId"  @close="isDeactivateModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading">Are you sure you want to deactivate? </div>
      <div slot="body">

      </div>
      <div slot="footer" class="col-3 override-padding">
        <button class="left col-12 btn btn-red" @click="deactivateSection(deactivateId)">Confirm</button>
      </div>
    </DeactivateModal>

    <SectionValidationModal :isModalVisible="isSectionValidationModalVisible" @close="isSectionValidationModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading">Section - '{{ validateSectionTitle }}' already added in this assessment.</div>
      <div slot="body">

      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </SectionValidationModal>

  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import { store } from '../../store/store';
import router from '../../router/index.js';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import VeeValidate from 'vee-validate';
import CreateAssessmentSectionModal from '../admin/create-assessment-section-modal.vue';
import EditAssessmentSectionModal from '../admin/edit_assessment_section_modal.vue';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import DeleteModal from '../shared/delete_modal_alert.vue';
import DeactivateModal from '../shared/delete_modal_alert.vue';
import SectionValidationModal from '../shared/validation_modal_alert.vue';
import { VueEditor } from "vue2-editor";

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

const today = new Date();
today.setHours(0, 0, 0, 0);

export default {
        data() {
          return {
            filterFlag: false,
            rows: 0,
            perPage: 25,
            currentPage: 1,
            assessment_section_lists: [],
            search_scale: '',
            scale_options: [
              { value: '', text: 'Select Scale' },
              { value: '1', text: '1-3:D/N/A' },
              { value: '2', text: '1-5:SD/D/N/A/SA' },
              { value: '3', text: '1-7:VSD/SD/D/N/A/SA/VSA' }
            ],
            search_status: '',
            status_options: [
              { value: '', text: 'Status' },
              { value: 'DRAFT', text: 'Draft' },
              { value: 'PUBLISH', text: 'Published' },
              { value: 'DEACTIVATED', text: 'Deactivated' }
            ],
            masterAdmin: false,
            admin: false,
            search_keyword: '',
            loading: false,
            sortField: 'title',
            sortBy: 'ASC',
            search_date: '',
            search_user: '',
            user_options: [],
            isModalVisible: false,
            assessment_section_title: '',
            scale: '2',
            section_type: 'no-output',
            section_type_options: [
              { value: '', text: 'Type' },
              { value: 'output', text: 'Output' },
              { value: 'no-output', text: 'No output' },
            ],
            section_range_display: false,
            group_options: [
              { value: '', text: 'Select' },
              { value: 'A', text: 'A' },
              { value: 'B', text: 'B' },
              { value: 'C', text: 'C' },
              { value: 'D', text: 'D' },
              { value: 'E', text: 'E' },
              { value: 'F', text: 'F' },
              { value: 'G', text: 'G' },
              { value: 'H', text: 'H' },
              { value: 'I', text: 'I' },
              { value: 'J', text: 'J' },
              { value: 'K', text: 'K' },
            ],
            type_options: [
              { value: '', text: 'Select' },
              { value: 'Global', text: 'Global' },
              { value: 'Intuitive', text: 'Intuitive' },
              { value: 'Individual', text: 'Individual' },
              { value: 'Negative', text: 'Negative' },
            ],
            statement_questions: [
              {
                group: '',
                type: '',
                text: '',
              }
            ],
            group_a_range: [
              {
                from: '',
                to: '',
                text: '',
              }
            ],
            group_b_range: [
              {
                from: '',
                to: '',
                text: '',
              }
            ],
            group_c_range: [
              {
                from: '',
                to: '',
                text: '',
              }
            ],
            group_d_range: [
              {
                from: '',
                to: '',
                text: '',
              }
            ],
            group_e_range: [
              {
                from: '',
                to: '',
                text: '',
              }
            ],
            group_f_range: [
              {
                from: '',
                to: '',
                text: '',
              }
            ],
            group_g_range: [
              {
                from: '',
                to: '',
                text: '',
              }
            ],
            group_h_range: [
              {
                from: '',
                to: '',
                text: '',
              }
            ],
            group_i_range: [
              {
                from: '',
                to: '',
                text: '',
              }
            ],
            group_j_range: [
              {
                from: '',
                to: '',
                text: '',
              }
            ],
            group_k_range: [
              {
                from: '',
                to: '',
                text: '',
              }
            ],
            index: 1,
            id: '',
            deactivateId: '',
            isDeleteModalVisible: false,
            isDeactivateModalVisible: false,
            showOverlay: false,
            sections_selected: [],
            assessment_id: '',
            assessment_section_obj: {
              assessment: [],
              sections: [],
              section_sort_flag: false,
              remove_sections: [],
            },
            validateSectionTitle: '',
            isSectionValidationModalVisible: false,
            isEditModalVisible: false,
            editSectionId: '',
            checkboxVisible: 0,
            customToolbar:[["bold", "italic", "underline"]]
          }
        },

        components: {
          UserMenu,
          GoBack,
          MasteradminSidebarMenu,
          CreateAssessmentSectionModal,
          DatePicker,
          DeleteModal,
          DeactivateModal,
          SectionValidationModal,
          EditAssessmentSectionModal,
          VueEditor
        },
        methods: {
            closeModal() {
              this.$emit('close');
            },
            scrollTo: function(arg) {
              if(arg == 'Top') {
                let elmnt = document.getElementById('top');
                elmnt.scrollIntoView(true);
              }
              else {
                let elmnt = document.getElementById('top');
                elmnt.scrollIntoView(false);
              }
            },
            sectionRangeDisplay: function() {
              this.section_range_display = true;
              if(this.section_type == 'no-output') {
                this.section_range_display = false;
                for(var i=0; i<this.statement_questions.length; i++) {
                  this.statement_questions[i].group = '';
                }
              }
            },
            truncate: function (text) {
              if (text.length > 10) {
                  return text.substring(0, 10) + '...';
              } else {
                  return text;
              }
            },
            editSectionMethod: function(section_id) {
              this.isEditModalVisible = true;
              this.editSectionId = section_id;
              this.$refs.EditModal.fetchSectionDetails(this.editSectionId);
            },
            onSubmit () {
                this.$validator.validateAll().then((result) => {
                  if(!result) {
                    return;
                  }
                  this.choosedSections();
                })
                .catch(() => {
                });
            },
            choosedSections: function() {
              if(this.sections_selected.length > 0) {
                for(var i=0; i<this.sections_selected.length; i++) {
                  var index = this.assessment_section_lists.findIndex(item => item.id == this.sections_selected[i]);
                  var selected_section = this.assessment_section_lists[index];

                  var duplicate_flag = this.checkSectionsAction(selected_section.id);

                  if(duplicate_flag == 1) {
                    this.validateSectionTitle = selected_section.title;
                    this.isSectionValidationModalVisible = true;
                    this.sections_selected.splice(i, 1);
                    return false;
                  }
                  axios.get('/assessment-section-details/' + selected_section.id)
                  .then((resp) => {
                      var section_len = this.assessment_section_obj.sections.length + 1;
                      this.assessment_section_obj.sections.push({
                        id: resp.data.sections.id,
                        title: resp.data.sections.title,
                        scale: resp.data.sections.scale,
                        group: resp.data.sections.group,
                        type: resp.data.sections.type,
                        minrange: resp.data.sections.minrange,
                        maxrange: resp.data.sections.maxrange,
                        edit: false,
                        update: false,
                        modified: false,
                        sortid: 'section-' + section_len,
                      });
                      this.$store.dispatch('assessment_sections', this.assessment_section_obj);
                  })
                  .catch(error => {

                  });
                }
                router.push("/assessment-add-section/" + this.$route.params.assessment_id);
              }

            },
            checkSectionsAction: function(section_id) {
              var duplicate_flag = 0;
              for(var k=0; k < this.assessment_section_obj.sections.length; k++)  {
                if(section_id == this.assessment_section_obj.sections[k].id) {
                  duplicate_flag = 1;
                }
              }
              return duplicate_flag;
            },

            addMoreQuestions: function() {
              if(this.statement_questions.length >= 100) {
                alert("You can't add more than 100 Statement/Questions");
                return false;
              }
              this.statement_questions.push({
                group: '',
                type: '',
                text: '',
              });
            },
            updateSectionStatus(section_id, status_text) {
              this.showOverlay = true;
              axios('/assessment-section-status/' + section_id,
               {
                 method: 'PATCH',
                 data: { "status": status_text},
               }
              )
              .then((resp) => {
                this.showOverlay = false;
                this.fetchAssessmentSectionitems();
              })
              .catch(error => {
                  if(error.response.data.message == 'Access denied.') {
                    router.push("/forbidden");
                  }
              });
            },

            deactivateSectionConfirm(section_id) {
              this.isDeactivateModalVisible = true;
              this.deactivateId = section_id;
            },
            deactivateSection(section_id) {
              this.isDeactivateModalVisible = false;
              this.showOverlay = true;
              axios('/assessment-section-status/' + section_id,
                {
                  method: 'PATCH',
                  data: { "status": 'DEACTIVATED'},
                }
              )
              .then((resp) => {
                this.showOverlay = false;
                this.fetchAssessmentSectionitems();
              })
              .catch(error => {
                if(error.response.data.message == 'Access denied.') {
                  router.push("/forbidden");
                }
              });
            },
            deleteSectionConfirm: function(section_id) {
              this.isDeleteModalVisible = true;
              this.id = section_id;
            },
            deleteSection: function(section_id) {
              this.isDeleteModalVisible = false;
              this.showOverlay = true;
              axios('/assessment-section/' + section_id,
                 {
                   method: 'DELETE',
                 }
               )
              .then((resp) => {
                  this.showOverlay = false;
                  this.fetchAssessmentSectionitems();
               })
              .catch(error => {

              });
            },

            isNumeric(value){
              var regex = /^[0-9]*$/
              return regex.test(value);
            },
            checkRangeNumbers: function(index, arg, group) {
              var scale = this.scale;
              if(this.scale == '') {
                alert("Please select Scale");
                return false;
              }
              if(group == 'A') {
                if(!this.isNumeric(this.group_a_range[index].from)) {
                  this.group_a_range[index].from = '';
                  return false;
                }
                if(!this.isNumeric(this.group_a_range[index].to)) {
                  this.group_a_range[index].to = '';
                  return false;
                }
                var val = this.getMinMaxRange(group);
                var minRange = val[0].min;
                var maxRange = val[0].max;
                if((index == 0) && (arg == 'From')) {
                  if(parseInt(this.group_a_range[index].from) != parseInt(minRange)) {
                    alert("From range should be equal to the count of questions of that group");
                    this.group_a_range[index].from = '';
                    return false;
                  }
                }
                if((index > 0) && (arg == 'From')) {
                  var preIndex = parseInt(index-1);
                  if(parseInt(this.group_a_range[index].from) <= parseInt(this.group_a_range[preIndex].to)) {
                    alert("From range should be higher than the previous To range");
                    this.group_a_range[index].from = '';
                    return false;
                  }
                }
                if((parseInt(index+1) == this.group_a_range.length) && (arg == 'To')) {
                  if(parseInt(this.group_a_range[index].to) > parseInt(maxRange)) {
                    alert("To range should be lesser or equal to the maximum range");
                    this.group_a_range[index].to = '';
                    return false;
                  }
                  else {
                    if(parseInt(this.group_a_range[index].from) > parseInt(this.group_a_range[index].to)) {
                      alert("To range should be higher than the From range");
                      this.group_a_range[index].to = '';
                      return false;
                    }
                  }
                }
                if((parseInt(index+1) < this.group_a_range.length) && (arg == 'To')) {
                  if(parseInt(this.group_a_range[index].from) > parseInt(this.group_a_range[index].to)) {
                    alert("To range should be higher than the From range");
                    this.group_a_range[index].to = '';
                    return false;
                  }
                }
              }
              else if(group == 'B') {
                if(!this.isNumeric(this.group_b_range[index].from)) {
                  this.group_b_range[index].from = '';
                  return false;
                }
                if(!this.isNumeric(this.group_b_range[index].to)) {
                  this.group_b_range[index].to = '';
                  return false;
                }
                var val = this.getMinMaxRange(group);
                var minRange = val[0].min;
                var maxRange = val[0].max;
                if((index == 0) && (arg == 'From')) {
                  if(parseInt(this.group_b_range[index].from) != parseInt(minRange)) {
                    alert("From range should be equal to the count of questions of that group");
                    this.group_b_range[index].from = '';
                    return false;
                  }
                }
                if((index > 0) && (arg == 'From')) {
                  var preIndex = parseInt(index-1);
                  if(parseInt(this.group_b_range[index].from) <= parseInt(this.group_b_range[preIndex].to)) {
                    alert("From range should be higher than the previous To range");
                    this.group_b_range[index].from = '';
                    return false;
                  }
                }
                if((parseInt(index+1) == this.group_b_range.length) && (arg == 'To')) {
                  if(parseInt(this.group_b_range[index].to) > parseInt(maxRange)) {
                    alert("To range should be lesser or equal to the maximum range");
                    this.group_b_range[index].to = '';
                    return false;
                  }
                  else {
                    if(parseInt(this.group_b_range[index].from) > parseInt(this.group_b_range[index].to)) {
                      alert("To range should be higher than the From range");
                      this.group_b_range[index].to = '';
                      return false;
                    }
                  }
                }
                if((parseInt(index+1) < this.group_b_range.length) && (arg == 'To')) {
                  if(parseInt(this.group_b_range[index].from) > parseInt(this.group_b_range[index].to)) {
                    alert("To range should be higher than the From range");
                    this.group_b_range[index].to = '';
                    return false;
                  }
                }
              } else if(group == 'C') {
                if(!this.isNumeric(this.group_c_range[index].from)) {
                  this.group_c_range[index].from = '';
                  return false;
                }
                if(!this.isNumeric(this.group_c_range[index].to)) {
                  this.group_c_range[index].to = '';
                  return false;
                }
                var val = this.getMinMaxRange(group);
                var minRange = val[0].min;
                var maxRange = val[0].max;
                if((index == 0) && (arg == 'From')) {
                  if(parseInt(this.group_c_range[index].from) != parseInt(minRange)) {
                    alert("From range should be equal to the count of questions of that group");
                    this.group_c_range[index].from = '';
                    return false;
                  }
                }
                if((index > 0) && (arg == 'From')) {
                  var preIndex = parseInt(index-1);
                  if(parseInt(this.group_c_range[index].from) <= parseInt(this.group_c_range[preIndex].to)) {
                    alert("From range should be higher than the previous To range");
                    this.group_c_range[index].from = '';
                    return false;
                  }
                }
                if((parseInt(index+1) == this.group_c_range.length) && (arg == 'To')) {
                  if(parseInt(this.group_c_range[index].to) > parseInt(maxRange)) {
                    alert("To range should be lesser or equal to the maximum range");
                    this.group_c_range[index].to = '';
                    return false;
                  }
                  else {
                    if(parseInt(this.group_c_range[index].from) > parseInt(this.group_c_range[index].to)) {
                      alert("To range should be higher than the From range");
                      this.group_c_range[index].to = '';
                      return false;
                    }
                  }
                }
                if((parseInt(index+1) < this.group_c_range.length) && (arg == 'To')) {
                  if(parseInt(this.group_c_range[index].from) > parseInt(this.group_c_range[index].to)) {
                    alert("To range should be higher than the From range");
                    this.group_c_range[index].to = '';
                    return false;
                  }
                }
              }
              else if(group == 'D') {
                if(!this.isNumeric(this.group_d_range[index].from)) {
                  this.group_d_range[index].from = '';
                  return false;
                }
                if(!this.isNumeric(this.group_d_range[index].to)) {
                  this.group_d_range[index].to = '';
                  return false;
                }
                var val = this.getMinMaxRange(group);
                var minRange = val[0].min;
                var maxRange = val[0].max;
                if((index == 0) && (arg == 'From')) {
                  if(parseInt(this.group_d_range[index].from) != parseInt(minRange)) {
                    alert("From range should be equal to the count of questions of that group");
                    this.group_d_range[index].from = '';
                    return false;
                  }
                }
                if((index > 0) && (arg == 'From')) {
                  var preIndex = parseInt(index-1);
                  if(parseInt(this.group_d_range[index].from) <= parseInt(this.group_d_range[preIndex].to)) {
                    alert("From range should be higher than the previous To range");
                    this.group_d_range[index].from = '';
                    return false;
                  }
                }
                if((parseInt(index+1) == this.group_d_range.length) && (arg == 'To')) {
                  if(parseInt(this.group_d_range[index].to) > parseInt(maxRange)) {
                    alert("To range should be lesser or equal to the maximum range");
                    this.group_d_range[index].to = '';
                    return false;
                  }
                  else {
                    if(parseInt(this.group_d_range[index].from) > parseInt(this.group_d_range[index].to)) {
                      alert("To range should be higher than the From range");
                      this.group_d_range[index].to = '';
                      return false;
                    }
                  }
                }
                if((parseInt(index+1) < this.group_d_range.length) && (arg == 'To')) {
                  if(parseInt(this.group_d_range[index].from) > parseInt(this.group_d_range[index].to)) {
                    alert("To range should be higher than the From range");
                    this.group_d_range[index].to = '';
                    return false;
                  }
                }
              }
              else if(group == 'E') {
                if(!this.isNumeric(this.group_e_range[index].from)) {
                  this.group_e_range[index].from = '';
                  return false;
                }
                if(!this.isNumeric(this.group_e_range[index].to)) {
                  this.group_e_range[index].to = '';
                  return false;
                }
                var val = this.getMinMaxRange(group);
                var minRange = val[0].min;
                var maxRange = val[0].max;
                if((index == 0) && (arg == 'From')) {
                  if(parseInt(this.group_e_range[index].from) != parseInt(minRange)) {
                    alert("From range should be equal to the count of questions of that group");
                    this.group_e_range[index].from = '';
                    return false;
                  }
                }
                if((index > 0) && (arg == 'From')) {
                  var preIndex = parseInt(index-1);
                  if(parseInt(this.group_e_range[index].from) <= parseInt(this.group_e_range[preIndex].to)) {
                    alert("From range should be higher than the previous To range");
                    this.group_e_range[index].from = '';
                    return false;
                  }
                }
                if((parseInt(index+1) == this.group_e_range.length) && (arg == 'To')) {
                  if(parseInt(this.group_e_range[index].to) > parseInt(maxRange)) {
                    alert("To range should be lesser or equal to the maximum range");
                    this.group_e_range[index].to = '';
                    return false;
                  }
                  else {
                    if(parseInt(this.group_e_range[index].from) > parseInt(this.group_e_range[index].to)) {
                      alert("To range should be higher than the From range");
                      this.group_e_range[index].to = '';
                      return false;
                    }
                  }
                }
                if((parseInt(index+1) < this.group_e_range.length) && (arg == 'To')) {
                  if(parseInt(this.group_e_range[index].from) > parseInt(this.group_e_range[index].to)) {
                    alert("To range should be higher than the From range");
                    this.group_e_range[index].to = '';
                    return false;
                  }
                }
              }
              else if(group == 'F') {
                if(!this.isNumeric(this.group_f_range[index].from)) {
                  this.group_f_range[index].from = '';
                  return false;
                }
                if(!this.isNumeric(this.group_f_range[index].to)) {
                  this.group_f_range[index].to = '';
                  return false;
                }
                var val = this.getMinMaxRange(group);
                var minRange = val[0].min;
                var maxRange = val[0].max;
                if((index == 0) && (arg == 'From')) {
                  if(parseInt(this.group_f_range[index].from) != parseInt(minRange)) {
                    alert("From range should be equal to the count of questions of that group");
                    this.group_f_range[index].from = '';
                    return false;
                  }
                }
                if((index > 0) && (arg == 'From')) {
                  var preIndex = parseInt(index-1);
                  if(parseInt(this.group_f_range[index].from) <= parseInt(this.group_f_range[preIndex].to)) {
                    alert("From range should be higher than the previous To range");
                    this.group_f_range[index].from = '';
                    return false;
                  }
                }
                if((parseInt(index+1) == this.group_f_range.length) && (arg == 'To')) {
                  if(parseInt(this.group_f_range[index].to) > parseInt(maxRange)) {
                    alert("To range should be lesser or equal to the maximum range");
                    this.group_f_range[index].to = '';
                    return false;
                  }
                  else {
                    if(parseInt(this.group_f_range[index].from) > parseInt(this.group_f_range[index].to)) {
                      alert("To range should be higher than the From range");
                      this.group_f_range[index].to = '';
                      return false;
                    }
                  }
                }
                if((parseInt(index+1) < this.group_f_range.length) && (arg == 'To')) {
                  if(parseInt(this.group_f_range[index].from) > parseInt(this.group_f_range[index].to)) {
                    alert("To range should be higher than the From range");
                    this.group_f_range[index].to = '';
                    return false;
                  }
                }
              }
              else if(group == 'G') {
                if(!this.isNumeric(this.group_g_range[index].from)) {
                  this.group_g_range[index].from = '';
                  return false;
                }
                if(!this.isNumeric(this.group_g_range[index].to)) {
                  this.group_g_range[index].to = '';
                  return false;
                }
                var val = this.getMinMaxRange(group);
                var minRange = val[0].min;
                var maxRange = val[0].max;
                if((index == 0) && (arg == 'From')) {
                  if(parseInt(this.group_g_range[index].from) != parseInt(minRange)) {
                    alert("From range should be equal to the count of questions of that group");
                    this.group_g_range[index].from = '';
                    return false;
                  }
                }
                if((index > 0) && (arg == 'From')) {
                  var preIndex = parseInt(index-1);
                  if(parseInt(this.group_g_range[index].from) <= parseInt(this.group_g_range[preIndex].to)) {
                    alert("From range should be higher than the previous To range");
                    this.group_g_range[index].from = '';
                    return false;
                  }
                }
                if((parseInt(index+1) == this.group_g_range.length) && (arg == 'To')) {
                  if(parseInt(this.group_g_range[index].to) > parseInt(maxRange)) {
                    alert("To range should be lesser or equal to the maximum range");
                    this.group_g_range[index].to = '';
                    return false;
                  }
                  else {
                    if(parseInt(this.group_g_range[index].from) > parseInt(this.group_g_range[index].to)) {
                      alert("To range should be higher than the From range");
                      this.group_g_range[index].to = '';
                      return false;
                    }
                  }
                }
                if((parseInt(index+1) < this.group_g_range.length) && (arg == 'To')) {
                  if(parseInt(this.group_g_range[index].from) > parseInt(this.group_g_range[index].to)) {
                    alert("To range should be higher than the From range");
                    this.group_g_range[index].to = '';
                    return false;
                  }
                }
              }
              else if(group == 'H') {
                if(!this.isNumeric(this.group_h_range[index].from)) {
                  this.group_h_range[index].from = '';
                  return false;
                }
                if(!this.isNumeric(this.group_h_range[index].to)) {
                  this.group_h_range[index].to = '';
                  return false;
                }
                var val = this.getMinMaxRange(group);
                var minRange = val[0].min;
                var maxRange = val[0].max;
                if((index == 0) && (arg == 'From')) {
                  if(parseInt(this.group_h_range[index].from) != parseInt(minRange)) {
                    alert("From range should be equal to the count of questions of that group");
                    this.group_h_range[index].from = '';
                    return false;
                  }
                }
                if((index > 0) && (arg == 'From')) {
                  var preIndex = parseInt(index-1);
                  if(parseInt(this.group_h_range[index].from) <= parseInt(this.group_h_range[preIndex].to)) {
                    alert("From range should be higher than the previous To range");
                    this.group_h_range[index].from = '';
                    return false;
                  }
                }
                if((parseInt(index+1) == this.group_h_range.length) && (arg == 'To')) {
                  if(parseInt(this.group_h_range[index].to) > parseInt(maxRange)) {
                    alert("To range should be lesser or equal to the maximum range");
                    this.group_h_range[index].to = '';
                    return false;
                  }
                  else {
                    if(parseInt(this.group_h_range[index].from) > parseInt(this.group_h_range[index].to)) {
                      alert("To range should be higher than the From range");
                      this.group_h_range[index].to = '';
                      return false;
                    }
                  }
                }
                if((parseInt(index+1) < this.group_h_range.length) && (arg == 'To')) {
                  if(parseInt(this.group_h_range[index].from) > parseInt(this.group_h_range[index].to)) {
                    alert("To range should be higher than the From range");
                    this.group_h_range[index].to = '';
                    return false;
                  }
                }
              }
              else if(group == 'I') {
                if(!this.isNumeric(this.group_i_range[index].from)) {
                  this.group_i_range[index].from = '';
                  return false;
                }
                if(!this.isNumeric(this.group_i_range[index].to)) {
                  this.group_i_range[index].to = '';
                  return false;
                }
                var val = this.getMinMaxRange(group);
                var minRange = val[0].min;
                var maxRange = val[0].max;
                if((index == 0) && (arg == 'From')) {
                  if(parseInt(this.group_i_range[index].from) != parseInt(minRange)) {
                    alert("From range should be equal to the count of questions of that group");
                    this.group_i_range[index].from = '';
                    return false;
                  }
                }
                if((index > 0) && (arg == 'From')) {
                  var preIndex = parseInt(index-1);
                  if(parseInt(this.group_i_range[index].from) <= parseInt(this.group_i_range[preIndex].to)) {
                    alert("From range should be higher than the previous To range");
                    this.group_i_range[index].from = '';
                    return false;
                  }
                }
                if((parseInt(index+1) == this.group_i_range.length) && (arg == 'To')) {
                  if(parseInt(this.group_i_range[index].to) > parseInt(maxRange)) {
                    alert("To range should be lesser or equal to the maximum range");
                    this.group_i_range[index].to = '';
                    return false;
                  }
                  else {
                    if(parseInt(this.group_i_range[index].from) > parseInt(this.group_i_range[index].to)) {
                      alert("To range should be higher than the From range");
                      this.group_i_range[index].to = '';
                      return false;
                    }
                  }
                }
                if((parseInt(index+1) < this.group_i_range.length) && (arg == 'To')) {
                  if(parseInt(this.group_i_range[index].from) > parseInt(this.group_i_range[index].to)) {
                    alert("To range should be higher than the From range");
                    this.group_i_range[index].to = '';
                    return false;
                  }
                }
              }
              else if(group == 'J') {
                if(!this.isNumeric(this.group_j_range[index].from)) {
                  this.group_j_range[index].from = '';
                  return false;
                }
                if(!this.isNumeric(this.group_j_range[index].to)) {
                  this.group_j_range[index].to = '';
                  return false;
                }
                var val = this.getMinMaxRange(group);
                var minRange = val[0].min;
                var maxRange = val[0].max;
                if((index == 0) && (arg == 'From')) {
                  if(parseInt(this.group_j_range[index].from) != parseInt(minRange)) {
                    alert("From range should be equal to the count of questions of that group");
                    this.group_j_range[index].from = '';
                    return false;
                  }
                }
                if((index > 0) && (arg == 'From')) {
                  var preIndex = parseInt(index-1);
                  if(parseInt(this.group_j_range[index].from) <= parseInt(this.group_j_range[preIndex].to)) {
                    alert("From range should be higher than the previous To range");
                    this.group_j_range[index].from = '';
                    return false;
                  }
                }
                if((parseInt(index+1) == this.group_j_range.length) && (arg == 'To')) {
                  if(parseInt(this.group_j_range[index].to) > parseInt(maxRange)) {
                    alert("To range should be lesser or equal to the maximum range");
                    this.group_j_range[index].to = '';
                    return false;
                  }
                  else {
                    if(parseInt(this.group_j_range[index].from) > parseInt(this.group_j_range[index].to)) {
                      alert("To range should be higher than the From range");
                      this.group_j_range[index].to = '';
                      return false;
                    }
                  }
                }
                if((parseInt(index+1) < this.group_j_range.length) && (arg == 'To')) {
                  if(parseInt(this.group_j_range[index].from) > parseInt(this.group_j_range[index].to)) {
                    alert("To range should be higher than the From range");
                    this.group_j_range[index].to = '';
                    return false;
                  }
                }
              }
              else if(group == 'K') {
                if(!this.isNumeric(this.group_k_range[index].from)) {
                  this.group_k_range[index].from = '';
                  return false;
                }
                if(!this.isNumeric(this.group_k_range[index].to)) {
                  this.group_k_range[index].to = '';
                  return false;
                }
                var val = this.getMinMaxRange(group);
                var minRange = val[0].min;
                var maxRange = val[0].max;
                if((index == 0) && (arg == 'From')) {
                  if(parseInt(this.group_k_range[index].from) != parseInt(minRange)) {
                    alert("From range should be equal to the count of questions of that group");
                    this.group_k_range[index].from = '';
                    return false;
                  }
                }
                if((index > 0) && (arg == 'From')) {
                  var preIndex = parseInt(index-1);
                  if(parseInt(this.group_k_range[index].from) <= parseInt(this.group_k_range[preIndex].to)) {
                    alert("From range should be higher than the previous To range");
                    this.group_k_range[index].from = '';
                    return false;
                  }
                }
                if((parseInt(index+1) == this.group_k_range.length) && (arg == 'To')) {
                  if(parseInt(this.group_k_range[index].to) > parseInt(maxRange)) {
                    alert("To range should be lesser or equal to the maximum range");
                    this.group_k_range[index].to = '';
                    return false;
                  }
                  else {
                    if(parseInt(this.group_k_range[index].from) > parseInt(this.group_k_range[index].to)) {
                      alert("To range should be higher than the From range");
                      this.group_k_range[index].to = '';
                      return false;
                    }
                  }
                }
                if((parseInt(index+1) < this.group_k_range.length) && (arg == 'To')) {
                  if(parseInt(this.group_k_range[index].from) > parseInt(this.group_k_range[index].to)) {
                    alert("To range should be higher than the From range");
                    this.group_k_range[index].to = '';
                    return false;
                  }
                }
              }
            },
            getMinMaxRange: function(arg) {
              var minmax = [{min: '', max: ''}];
              var min = '';
              var max = '';
              var minScale = '';
              var maxScale = '';
              var count = 0;
                for(var i=0; i<this.statement_questions.length; i++) {
                  if((this.statement_questions[i].group == arg)) {
                    count += 1;
                  }
              }
              var scale = this.scale;
              if(scale == 1) {
                minScale = 1;
                maxScale = 3;
              }
              else if(scale == 2) {
                minScale = 1;
                maxScale = 5;
              }
              else if(scale == 3) {
                minScale = 1;
                maxScale = 7;
              }
              if((minScale != '') && (maxScale != '')) {
                min = parseInt(count) * parseInt(minScale);
                max = parseInt(count) * parseInt(maxScale);
                minmax = [{min: min, max: max}];
              }
              return minmax;
            },
            checkVisible: function(arg) {
              var groupA = false;
              var groupB = false;
              var groupC = false;
              var groupD = false;
              var groupE = false;
              var groupF = false;
              var groupG = false;
              var groupH = false;
              var groupI = false;
              var groupJ = false;
              var groupK = false;
              for(var i=0; i<this.statement_questions.length; i++) {
                if((groupA == false) && (this.statement_questions[i].group == 'A')) {
                  groupA = true;
                }
                if((groupB == false) && (this.statement_questions[i].group == 'B')) {
                  groupB = true;
                }
                if((groupC == false) && (this.statement_questions[i].group == 'C')) {
                  groupC = true;
                }
                if((groupD == false) && (this.statement_questions[i].group == 'D')) {
                  groupD = true;
                }
                if((groupE == false) && (this.statement_questions[i].group == 'E')) {
                  groupE = true;
                }
                if((groupF == false) && (this.statement_questions[i].group == 'F')) {
                  groupF = true;
                }
                if((groupG == false) && (this.statement_questions[i].group == 'G')) {
                  groupG = true;
                }
                if((groupH == false) && (this.statement_questions[i].group == 'H')) {
                  groupH = true;
                }
                if((groupI == false) && (this.statement_questions[i].group == 'I')) {
                  groupI = true;
                }
                if((groupJ == false) && (this.statement_questions[i].group == 'J')) {
                  groupJ = true;
                }
                if((groupK == false) && (this.statement_questions[i].group == 'K')) {
                  groupK = true;
                }
              }
              if(arg == 'A') {
                return groupA;
              }
              else if(arg == 'B') {
                return groupB;
              }
              else if(arg == 'C') {
                return groupC;
              }
              else if(arg == 'D') {
                return groupD;
              }
              else if(arg == 'E') {
                return groupE;
              }
              else if(arg == 'F') {
                return groupF;
              }
              else if(arg == 'G') {
                return groupG;
              }
              else if(arg == 'H') {
                return groupH;
              }
              else if(arg == 'I') {
                return groupI;
              }
              else if(arg == 'J') {
                return groupJ;
              }
              else if(arg == 'K') {
                return groupK;
              }
            },
            addMoreOutputText: function(arg) {
              if(arg == 'A') {
                if(this.group_a_range.length >= 25) {
                  alert("You can't add more than 25 Output Ranges");
                  return false;
                }
                this.group_a_range.push({
                  from: '',
                  to: '',
                  text: '',
                });
              }
              else if(arg == 'B') {
                if(this.group_b_range.length >= 25) {
                  alert("You can't add more than 25 Output Ranges");
                  return false;
                }
                this.group_b_range.push({
                  from: '',
                  to: '',
                  text: '',
                });
              }
              else if(arg == 'C') {
                if(this.group_c_range.length >= 25) {
                  alert("You can't add more than 25 Output Ranges");
                  return false;
                }
                this.group_c_range.push({
                  from: '',
                  to: '',
                  text: '',
                });
              }
              else if(arg == 'D') {
                if(this.group_d_range.length >= 25) {
                  alert("You can't add more than 25 Output Ranges");
                  return false;
                }
                this.group_d_range.push({
                  from: '',
                  to: '',
                  text: '',
                });
              }
              else if(arg == 'E') {
                if(this.group_e_range.length >= 25) {
                  alert("You can't add more than 25 Output Ranges");
                  return false;
                }
                this.group_e_range.push({
                  from: '',
                  to: '',
                  text: '',
                });
              }
              else if(arg == 'F') {
                if(this.group_f_range.length >= 25) {
                  alert("You can't add more than 25 Output Ranges");
                  return false;
                }
                this.group_f_range.push({
                  from: '',
                  to: '',
                  text: '',
                });
              }
              else if(arg == 'G') {
                if(this.group_g_range.length >= 25) {
                  alert("You can't add more than 25 Output Ranges");
                  return false;
                }
                this.group_g_range.push({
                  from: '',
                  to: '',
                  text: '',
                });
              }
              else if(arg == 'H') {
                if(this.group_h_range.length >= 25) {
                  alert("You can't add more than 25 Output Ranges");
                  return false;
                }
                this.group_h_range.push({
                  from: '',
                  to: '',
                  text: '',
                });
              }
              else if(arg == 'I') {
                if(this.group_i_range.length >= 25) {
                  alert("You can't add more than 25 Output Ranges");
                  return false;
                }
                this.group_i_range.push({
                  from: '',
                  to: '',
                  text: '',
                });
              }
              else if(arg == 'J') {
                if(this.group_j_range.length >= 25) {
                  alert("You can't add more than 25 Output Ranges");
                  return false;
                }
                this.group_j_range.push({
                  from: '',
                  to: '',
                  text: '',
                });
              }
              else if(arg == 'K') {
                if(this.group_k_range.length >= 25) {
                  alert("You can't add more than 25 Output Ranges");
                  return false;
                }
                this.group_k_range.push({
                  from: '',
                  to: '',
                  text: '',
                });
              }
            },
            FollowDate(value) {
              return moment(String(value)).utc().format('MM/DD/YYYY')
            },
           sortMethod: function(field) {
             this.sortField = field;
             if(this.sortBy == 'ASC') {
               this.sortBy = 'DESC';
             }
             else {
               this.sortBy = 'ASC';
             }
             this.fetchAssessmentSectionitems();
           },
            showTasklistofPaginated() {
               this.fetchAssessmentSectionitems();
               this.filterFlag = false;
            },
            filterAssessmentSectionitems() {
               this.filterFlag = true;
               this.fetchAssessmentSectionitems();
            },
            fetchUserOptions: function() {
             axios.get('/masteradmin-useroptions', {

             })
             .then((response) => {
                 var user_option = {value: '', text: 'Created By'};
                 this.user_options.push(user_option);
                 for(var i=0; i < response.data.length; i++) {
                   var name = response.data[i].first_name + ' ' + response.data[i].last_name;
                   var user_option = {value: response.data[i].id, text: name};
                   this.user_options.push(user_option);
                 }
             })
             .catch(error => {

             });

           },
            doValidate: function() {
              var sflag = 0;
              var aflag = 0;
              var bflag = 0;
              var cflag = 0;
              var dflag = 0;
              var eflag = 0;
              var fflag = 0;
              var gflag = 0;
              var hflag = 0;
              var iflag = 0;
              var jflag = 0;
              var kflag = 0;
              var vflag = 1;
              for(var i=0; i<this.statement_questions.length; i++) {
                if(this.statement_questions[i].group != '') {
                  sflag = 1;
                }
                if(this.section_range_display == false) {
                  if(this.statement_questions[i].type != '') {
                    sflag = 1;
                  }
                }
                if(this.section_range_display == true) {
                  if(this.statement_questions[i].group == 'A') {
                    aflag = 1;
                  }
                  if(this.statement_questions[i].group == 'B') {
                    bflag = 1;
                  }
                  if(this.statement_questions[i].group == 'C') {
                    cflag = 1;
                  }
                  if(this.statement_questions[i].group == 'D') {
                    dflag = 1;
                  }
                  if(this.statement_questions[i].group == 'E') {
                    eflag = 1;
                  }
                  if(this.statement_questions[i].group == 'F') {
                    fflag = 1;
                  }
                  if(this.statement_questions[i].group == 'G') {
                    gflag = 1;
                  }
                  if(this.statement_questions[i].group == 'H') {
                    hflag = 1;
                  }
                  if(this.statement_questions[i].group == 'I') {
                    iflag = 1;
                  }
                  if(this.statement_questions[i].group == 'J') {
                    jflag = 1;
                  }
                  if(this.statement_questions[i].group == 'K') {
                    kflag = 1;
                  }
                }
              }
              if(sflag == 0) {
                alert("Please enter atleast one Statement/Questions");
                vflag = 0;
                return false;
              }
              if(aflag == 1) {
                var aaflag = 0;
                for(var i=0; i<this.group_a_range.length; i++) {
                  if(this.group_a_range[i].from != '') {
                    aaflag = 1;
                  }
                }
                if(aaflag == 0) {
                  alert("Please enter atleast one Output Range for Group A");
                  vflag = 0;
                  return false;
                }
              }
              else {
                this.group_a_range = [{
                  from: '',
                  to: '',
                  text: '',
                }];

              }
              if(bflag == 1) {
                var bbflag = 0;
                for(var i=0; i<this.group_b_range.length; i++) {
                  if(this.group_b_range[i].from != '') {
                    bbflag = 1;
                  }
                }
                if(bbflag == 0) {
                  alert("Please enter atleast one Output Range for Group B");
                  vflag = 0;
                  return false;
                }
              }
              else {
                this.group_b_range = [{
                  from: '',
                  to: '',
                  text: '',
                }];

              }
              if(cflag == 1) {
                var ccflag = 0;
                for(var i=0; i<this.group_c_range.length; i++) {
                  if(this.group_c_range[i].from != '') {
                    ccflag = 1;
                  }
                }
                if(ccflag == 0) {
                  alert("Please enter atleast one Output Range for Group C");
                  vflag = 0;
                  return false;
                }
              }
              else {
                this.group_c_range = [{
                  from: '',
                  to: '',
                  text: '',
                }];

              }
              if(dflag == 1) {
                var ddflag = 0;
                for(var i=0; i<this.group_d_range.length; i++) {
                  if(this.group_d_range[i].from != '') {
                    ddflag = 1;
                  }
                }
                if(ddflag == 0) {
                  alert("Please enter atleast one Output Range for Group D");
                  vflag = 0;
                  return false;
                }
              }
              else {
                this.group_d_range = [{
                  from: '',
                  to: '',
                  text: '',
                }];

              }
              if(eflag == 1) {
                var eeflag = 0;
                for(var i=0; i<this.group_e_range.length; i++) {
                  if(this.group_e_range[i].from != '') {
                    eeflag = 1;
                  }
                }
                if(eeflag == 0) {
                  alert("Please enter atleast one Output Range for Group E");
                  vflag = 0;
                  return false;
                }
              }
              else {
                this.group_e_range = [{
                  from: '',
                  to: '',
                  text: '',
                }];

              }
              if(fflag == 1) {
                var ffflag = 0;
                for(var i=0; i<this.group_f_range.length; i++) {
                  if(this.group_f_range[i].from != '') {
                    ffflag = 1;
                  }
                }
                if(ffflag == 0) {
                  alert("Please enter atleast one Output Range for Group F");
                  vflag = 0;
                  return false;
                }
              }
              else {
                this.group_f_range = [{
                  from: '',
                  to: '',
                  text: '',
                }];

              }
              if(gflag == 1) {
                var ggflag = 0;
                for(var i=0; i<this.group_g_range.length; i++) {
                  if(this.group_g_range[i].from != '') {
                    ggflag = 1;
                  }
                }
                if(ggflag == 0) {
                  alert("Please enter atleast one Output Range for Group G");
                  vflag = 0;
                  return false;
                }
              }
              else {
                this.group_g_range = [{
                  from: '',
                  to: '',
                  text: '',
                }];

              }
              if(hflag == 1) {
                var hhflag = 0;
                for(var i=0; i<this.group_h_range.length; i++) {
                  if(this.group_h_range[i].from != '') {
                    hhflag = 1;
                  }
                }
                if(hhflag == 0) {
                  alert("Please enter atleast one Output Range for Group H");
                  vflag = 0;
                  return false;
                }
              }
              else {
                this.group_h_range = [{
                  from: '',
                  to: '',
                  text: '',
                }];

              }
              if(iflag == 1) {
                var iiflag = 0;
                for(var i=0; i<this.group_i_range.length; i++) {
                  if(this.group_i_range[i].from != '') {
                    iiflag = 1;
                  }
                }
                if(iiflag == 0) {
                  alert("Please enter atleast one Output Range for Group I");
                  vflag = 0;
                  return false;
                }
              }
              else {
                this.group_i_range = [{
                  from: '',
                  to: '',
                  text: '',
                }];

              }
              if(jflag == 1) {
                var jjflag = 0;
                for(var i=0; i<this.group_j_range.length; i++) {
                  if(this.group_j_range[i].from != '') {
                    jjflag = 1;
                  }
                }
                if(jjflag == 0) {
                  alert("Please enter atleast one Output Range for Group J");
                  vflag = 0;
                  return false;
                }
              }
              else {
                this.group_j_range = [{
                  from: '',
                  to: '',
                  text: '',
                }];

              }
              if(kflag == 1) {
                var kkflag = 0;
                for(var i=0; i<this.group_k_range.length; i++) {
                  if(this.group_k_range[i].from != '') {
                    kkflag = 1;
                  }
                }
                if(kkflag == 0) {
                  alert("Please enter atleast one Output Range for Group K");
                  vflag = 0;
                  return false;
                }
              }
              else {
                this.group_k_range = [{
                  from: '',
                  to: '',
                  text: '',
                }];

              }
              for(var i=0; i<this.statement_questions.length; i++) {
                if(this.section_range_display == true) {
                  if((this.statement_questions[i].group != '') && ((this.statement_questions[i].type == '') || (this.statement_questions[i].text == ''))) {
                    if(this.statement_questions[i].type == '') {
                      alert("Type should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.statement_questions[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                }
                if((this.statement_questions[i].type != '') && ((this.statement_questions[i].group == '') || (this.statement_questions[i].text == ''))) {
                  if(this.section_range_display == true) {
                    if(this.statement_questions[i].group == '') {
                      alert("Group should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if(this.statement_questions[i].text == '') {
                    alert("Text should be not be empty");
                    vflag = 0;
                    return false;
                  }
                }
                if((this.statement_questions[i].text != '') && ((this.statement_questions[i].group == '') || (this.statement_questions[i].type == ''))) {
                  if(this.section_range_display == true) {
                    if(this.statement_questions[i].group == '') {
                      alert("Group should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if(this.statement_questions[i].type == '') {
                    alert("Type should be not be empty");
                    vflag = 0;
                    return false;
                  }
                }
              }
              if(aflag == 1) {

                var val = this.getMinMaxRange('A');
                var minRange = val[0].min;
                var maxRange = val[0].max;

                var last_to_range = '';var j;
                for(var i=this.group_a_range.length; i>0; i--) {
                  j = parseInt(i - 1);
                  if((this.group_a_range[j].from != '') && (this.group_a_range[j].to != '')) {
                    last_to_range = j;
                    break;
                  }
                }  
                if(last_to_range > -1) {
                  if(this.group_a_range[last_to_range].to != maxRange) {
                    alert("Last To range should be equal to the maximum range");
                    vflag = 0;
                    this.group_a_range[last_to_range].to = '';
                    return false;
                  }
                } 
                for(var i=0; i<this.group_a_range.length; i++) {

                  if((i == 0)) {
                    if(this.group_a_range[i].from != minRange) {
                      alert("First From range should be equal to the count of questions of that group");
                      vflag = 0;
                      this.group_a_range[i].from = '';
                      return false;
                    }
                  }


                  if((this.group_a_range[i].from != '') && ((this.group_a_range[i].to == '') || (this.group_a_range[i].text == ''))) {
                    if(this.group_a_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_a_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.group_a_range[i].to != '') && ((this.group_a_range[i].from == '') || (this.group_a_range[i].text == ''))) {
                    if(this.group_a_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_a_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.group_a_range[i].text != '') && ((this.group_a_range[i].from == '') || (this.group_a_range[i].to == ''))) {
                    if(this.group_a_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_a_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                }

              }
              if(bflag == 1) {

                var val = this.getMinMaxRange('B');
                var minRange = val[0].min;
                var maxRange = val[0].max;

                var last_to_range = '';var j;
                for(var i=this.group_b_range.length; i>0; i--) {
                  j = parseInt(i - 1);
                  if((this.group_b_range[j].from != '') && (this.group_b_range[j].to != '')) {
                    last_to_range = j;
                    break;
                  }
                }  
                if(last_to_range > -1) {
                  if(this.group_b_range[last_to_range].to != maxRange) {
                    alert("Last To range should be equal to the maximum range");
                    vflag = 0;
                    this.group_b_range[last_to_range].to = '';
                    return false;
                  }
                }       

                for(var i=0; i<this.group_b_range.length; i++) {

                  if((i == 0)) {
                    if(this.group_b_range[i].from != minRange) {
                      alert("First From range should be equal to the count of questions of that group");
                      vflag = 0;
                      this.group_b_range[i].from = '';
                      return false;
                    }
                  }


                  if((this.group_b_range[i].from != '') && ((this.group_b_range[i].to == '') || (this.group_b_range[i].text == ''))) {
                    if(this.group_b_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_b_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.group_b_range[i].to != '') && ((this.group_b_range[i].from == '') || (this.group_b_range[i].text == ''))) {
                    if(this.group_b_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_b_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.group_b_range[i].text != '') && ((this.group_b_range[i].from == '') || (this.group_b_range[i].to == ''))) {
                    if(this.group_b_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_b_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                }

              }
              if(cflag == 1) {

                var val = this.getMinMaxRange('C');
                var minRange = val[0].min;
                var maxRange = val[0].max;

                var last_to_range = '';var j;
                for(var i=this.group_c_range.length; i>0; i--) {
                  j = parseInt(i - 1);
                  if((this.group_c_range[j].from != '') && (this.group_c_range[j].to != '')) {
                    last_to_range = j;
                    break;
                  }
                }  
                if(last_to_range > -1) {
                  if(this.group_c_range[last_to_range].to != maxRange) {
                    alert("Last To range should be equal to the maximum range");
                    vflag = 0;
                    this.group_c_range[last_to_range].to = '';
                    return false;
                  }
                }       

                for(var i=0; i<this.group_c_range.length; i++) {

                  if((i == 0)) {
                    if(this.group_c_range[i].from != minRange) {
                      alert("First From range should be equal to the count of questions of that group");
                      vflag = 0;
                      this.group_c_range[i].from = '';
                      return false;
                    }
                  }


                  if((this.group_c_range[i].from != '') && ((this.group_c_range[i].to == '') || (this.group_c_range[i].text == ''))) {
                    if(this.group_c_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_c_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.group_c_range[i].to != '') && ((this.group_c_range[i].from == '') || (this.group_c_range[i].text == ''))) {
                    if(this.group_c_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_c_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.group_c_range[i].text != '') && ((this.group_c_range[i].from == '') || (this.group_c_range[i].to == ''))) {
                    if(this.group_c_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_c_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                }

              }
              if(dflag == 1) {

                var val = this.getMinMaxRange('D');
                var minRange = val[0].min;
                var maxRange = val[0].max;

                var last_to_range = '';var j;
                for(var i=this.group_d_range.length; i>0; i--) {
                  j = parseInt(i - 1);
                  if((this.group_d_range[j].from != '') && (this.group_d_range[j].to != '')) {
                    last_to_range = j;
                    break;
                  }
                }  
                if(last_to_range > -1) {
                  if(this.group_d_range[last_to_range].to != maxRange) {
                    alert("Last To range should be equal to the maximum range");
                    vflag = 0;
                    this.group_d_range[last_to_range].to = '';
                    return false;
                  }
                }       

                for(var i=0; i<this.group_d_range.length; i++) {

                  if((i == 0)) {
                    if(this.group_d_range[i].from != minRange) {
                      alert("First From range should be equal to the count of questions of that group");
                      vflag = 0;
                      this.group_d_range[i].from = '';
                      return false;
                    }
                  }


                  if((this.group_d_range[i].from != '') && ((this.group_d_range[i].to == '') || (this.group_d_range[i].text == ''))) {
                    if(this.group_d_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_d_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.group_d_range[i].to != '') && ((this.group_d_range[i].from == '') || (this.group_d_range[i].text == ''))) {
                    if(this.group_d_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_d_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.group_d_range[i].text != '') && ((this.group_d_range[i].from == '') || (this.group_d_range[i].to == ''))) {
                    if(this.group_d_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_d_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                }

              }
              if(eflag == 1) {

                var val = this.getMinMaxRange('E');
                var minRange = val[0].min;
                var maxRange = val[0].max;

                var last_to_range = '';var j;
                for(var i=this.group_e_range.length; i>0; i--) {
                  j = parseInt(i - 1);
                  if((this.group_e_range[j].from != '') && (this.group_e_range[j].to != '')) {
                    last_to_range = j;
                    break;
                  }
                }  
                if(last_to_range > -1) {
                  if(this.group_e_range[last_to_range].to != maxRange) {
                    alert("Last To range should be equal to the maximum range");
                    vflag = 0;
                    this.group_e_range[last_to_range].to = '';
                    return false;
                  }
                }       

                for(var i=0; i<this.group_e_range.length; i++) {

                  if((i == 0)) {
                    if(this.group_e_range[i].from != minRange) {
                      alert("First From range should be equal to the count of questions of that group");
                      vflag = 0;
                      this.group_e_range[i].from = '';
                      return false;
                    }
                  }


                  if((this.group_e_range[i].from != '') && ((this.group_e_range[i].to == '') || (this.group_e_range[i].text == ''))) {
                    if(this.group_e_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_e_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.group_e_range[i].to != '') && ((this.group_e_range[i].from == '') || (this.group_e_range[i].text == ''))) {
                    if(this.group_e_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_e_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.group_e_range[i].text != '') && ((this.group_e_range[i].from == '') || (this.group_e_range[i].to == ''))) {
                    if(this.group_e_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_e_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                }

              }
              if(fflag == 1) {

                var val = this.getMinMaxRange('E');
                var minRange = val[0].min;
                var maxRange = val[0].max;

                var last_to_range = '';var j;
                for(var i=this.group_f_range.length; i>0; i--) {
                  j = parseInt(i - 1);
                  if((this.group_f_range[j].from != '') && (this.group_f_range[j].to != '')) {
                    last_to_range = j;
                    break;
                  }
                }  
                if(last_to_range > -1) {
                  if(this.group_f_range[last_to_range].to != maxRange) {
                    alert("Last To range should be equal to the maximum range");
                    vflag = 0;
                    this.group_f_range[last_to_range].to = '';
                    return false;
                  }
                }       

                for(var i=0; i<this.group_f_range.length; i++) {

                  if((i == 0)) {
                    if(this.group_f_range[i].from != minRange) {
                      alert("First From range should be equal to the count of questions of that group");
                      vflag = 0;
                      this.group_f_range[i].from = '';
                      return false;
                    }
                  }


                  if((this.group_f_range[i].from != '') && ((this.group_f_range[i].to == '') || (this.group_f_range[i].text == ''))) {
                    if(this.group_f_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_f_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.group_f_range[i].to != '') && ((this.group_f_range[i].from == '') || (this.group_f_range[i].text == ''))) {
                    if(this.group_f_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_f_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.group_f_range[i].text != '') && ((this.group_f_range[i].from == '') || (this.group_f_range[i].to == ''))) {
                    if(this.group_f_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_f_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                }

              }
              if(gflag == 1) {

                var val = this.getMinMaxRange('G');
                var minRange = val[0].min;
                var maxRange = val[0].max;

                var last_to_range = '';var j;
                for(var i=this.group_g_range.length; i>0; i--) {
                  j = parseInt(i - 1);
                  if((this.group_g_range[j].from != '') && (this.group_g_range[j].to != '')) {
                    last_to_range = j;
                    break;
                  }
                }  
                if(last_to_range > -1) {
                  if(this.group_g_range[last_to_range].to != maxRange) {
                    alert("Last To range should be equal to the maximum range");
                    vflag = 0;
                    this.group_g_range[last_to_range].to = '';
                    return false;
                  }
                }       

                for(var i=0; i<this.group_g_range.length; i++) {

                  if((i == 0)) {
                    if(this.group_g_range[i].from != minRange) {
                      alert("First From range should be equal to the count of questions of that group");
                      vflag = 0;
                      this.group_g_range[i].from = '';
                      return false;
                    }
                  }


                  if((this.group_g_range[i].from != '') && ((this.group_g_range[i].to == '') || (this.group_g_range[i].text == ''))) {
                    if(this.group_g_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_g_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.group_g_range[i].to != '') && ((this.group_g_range[i].from == '') || (this.group_g_range[i].text == ''))) {
                    if(this.group_g_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_g_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.group_g_range[i].text != '') && ((this.group_g_range[i].from == '') || (this.group_g_range[i].to == ''))) {
                    if(this.group_g_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_g_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                }

              }
              if(hflag == 1) {

                var val = this.getMinMaxRange('H');
                var minRange = val[0].min;
                var maxRange = val[0].max;

                var last_to_range = '';var j;
                for(var i=this.group_h_range.length; i>0; i--) {
                  j = parseInt(i - 1);
                  if((this.group_h_range[j].from != '') && (this.group_h_range[j].to != '')) {
                    last_to_range = j;
                    break;
                  }
                }  
                if(last_to_range > -1) {
                  if(this.group_h_range[last_to_range].to != maxRange) {
                    alert("Last To range should be equal to the maximum range");
                    vflag = 0;
                    this.group_h_range[last_to_range].to = '';
                    return false;
                  }
                }       

                for(var i=0; i<this.group_h_range.length; i++) {

                  if((i == 0)) {
                    if(this.group_h_range[i].from != minRange) {
                      alert("First From range should be equal to the count of questions of that group");
                      vflag = 0;
                      this.group_h_range[i].from = '';
                      return false;
                    }
                  }


                  if((this.group_h_range[i].from != '') && ((this.group_h_range[i].to == '') || (this.group_h_range[i].text == ''))) {
                    if(this.group_h_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_h_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.group_h_range[i].to != '') && ((this.group_h_range[i].from == '') || (this.group_h_range[i].text == ''))) {
                    if(this.group_h_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_h_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.group_h_range[i].text != '') && ((this.group_h_range[i].from == '') || (this.group_h_range[i].to == ''))) {
                    if(this.group_h_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_h_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                }

              }
              if(iflag == 1) {

                var val = this.getMinMaxRange('I');
                var minRange = val[0].min;
                var maxRange = val[0].max;

                var last_to_range = '';var j;
                for(var i=this.group_i_range.length; i>0; i--) {
                  j = parseInt(i - 1);
                  if((this.group_i_range[j].from != '') && (this.group_i_range[j].to != '')) {
                    last_to_range = j;
                    break;
                  }
                }  
                if(last_to_range > -1) {
                  if(this.group_i_range[last_to_range].to != maxRange) {
                    alert("Last To range should be equal to the maximum range");
                    vflag = 0;
                    this.group_i_range[last_to_range].to = '';
                    return false;
                  }
                }       

                for(var i=0; i<this.group_i_range.length; i++) {

                  if((i == 0)) {
                    if(this.group_i_range[i].from != minRange) {
                      alert("First From range should be equal to the count of questions of that group");
                      vflag = 0;
                      this.group_i_range[i].from = '';
                      return false;
                    }
                  }


                  if((this.group_i_range[i].from != '') && ((this.group_i_range[i].to == '') || (this.group_i_range[i].text == ''))) {
                    if(this.group_i_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_i_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.group_i_range[i].to != '') && ((this.group_i_range[i].from == '') || (this.group_i_range[i].text == ''))) {
                    if(this.group_i_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_i_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.group_i_range[i].text != '') && ((this.group_i_range[i].from == '') || (this.group_i_range[i].to == ''))) {
                    if(this.group_i_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_i_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                }

              }
              if(jflag == 1) {

                var val = this.getMinMaxRange('J');
                var minRange = val[0].min;
                var maxRange = val[0].max;

                var last_to_range = '';var j;
                for(var i=this.group_j_range.length; i>0; i--) {
                  j = parseInt(i - 1);
                  if((this.group_j_range[j].from != '') && (this.group_j_range[j].to != '')) {
                    last_to_range = j;
                    break;
                  }
                }  
                if(last_to_range > -1) {
                  if(this.group_j_range[last_to_range].to != maxRange) {
                    alert("Last To range should be equal to the maximum range");
                    vflag = 0;
                    this.group_j_range[last_to_range].to = '';
                    return false;
                  }

                }

                //for(var i=0; i<this.group_a_range.length; i++) {
                //}       

                for(var i=0; i<this.group_j_range.length; i++) {
                  if((i == 0)) {
                    if(this.group_j_range[i].from != minRange) {
                      alert("First From range should be equal to the count of questions of that group");
                      vflag = 0;
                      this.group_j_range[i].from = '';
                      return false;
                    }
                  }


                  if((this.group_j_range[i].from != '') && ((this.group_j_range[i].to == '') || (this.group_j_range[i].text == ''))) {
                    if(this.group_j_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_j_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.group_j_range[i].to != '') && ((this.group_j_range[i].from == '') || (this.group_j_range[i].text == ''))) {
                    if(this.group_j_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_j_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.group_j_range[i].text != '') && ((this.group_j_range[i].from == '') || (this.group_j_range[i].to == ''))) {
                    if(this.group_j_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_j_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                }

              }
              if(kflag == 1) {

                var val = this.getMinMaxRange('K');
                var minRange = val[0].min;
                var maxRange = val[0].max;

                var last_to_range = '';var j;
                for(var i=this.group_k_range.length; i>0; i--) {
                  j = parseInt(i - 1);
                  if((this.group_k_range[j].from != '') && (this.group_k_range[j].to != '')) {
                    last_to_range = j;
                    break;
                  }
                }  
                if(last_to_range > -1) {
                  if(this.group_k_range[last_to_range].to != maxRange) {
                    alert("Last To range should be equal to the maximum range");
                    vflag = 0;
                    this.group_k_range[last_to_range].to = '';
                    return false;
                  }
                }       

                for(var i=0; i<this.group_k_range.length; i++) {

                  if((i == 0)) {
                    if(this.group_k_range[i].from != minRange) {
                      alert("First From range should be equal to the count of questions of that group");
                      vflag = 0;
                      this.group_k_range[i].from = '';
                      return false;
                    }
                  }


                  if((this.group_k_range[i].from != '') && ((this.group_k_range[i].to == '') || (this.group_k_range[i].text == ''))) {
                    if(this.group_k_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_k_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.group_k_range[i].to != '') && ((this.group_k_range[i].from == '') || (this.group_k_range[i].text == ''))) {
                    if(this.group_k_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_k_range[i].text == '') {
                      alert("Text should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                  if((this.group_k_range[i].text != '') && ((this.group_k_range[i].from == '') || (this.group_k_range[i].to == ''))) {
                    if(this.group_k_range[i].from == '') {
                      alert("From range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                    if(this.group_k_range[i].to == '') {
                      alert("To range should be not be empty");
                      vflag = 0;
                      return false;
                    }
                  }
                }

              }
              return vflag;
            },
           createAssessmentSection: function(status) {
            this.$validator.validateAll().then((result) => {
              if ((this.verrors.items.length === 0)) {
                  var vflag = this.doValidate();
                  if(vflag == 1) {
                    axios('/assessment-section',
                       {
                         method: 'POST',
                         data:
                          {
                            title: this.assessment_section_title,
                            scale: this.scale,
                            type: this.section_type,
                            status: status,
                            questions: this.statement_questions,
                            group_a: this.group_a_range,
                            group_b: this.group_b_range,
                            group_c: this.group_c_range,
                            group_d: this.group_d_range,
                            group_e: this.group_e_range,
                            group_f: this.group_f_range,
                            group_g: this.group_g_range,
                            group_h: this.group_h_range,
                            group_i: this.group_i_range,
                            group_j: this.group_j_range,
                            group_k: this.group_k_range,
                          },
                       }
                     )
                    .then((resp) => {
                        this.assessment_section_title = '';
                        this.scale = '';
                        this.statement_questions = [
                          {
                            group: '',
                            type: '',
                            text: '',
                          }
                        ];
                        this.group_a_range = [
                          {
                            from: '',
                            to: '',
                            text: '',
                          }
                        ];
                        this.group_b_range = [
                          {
                            from: '',
                            to: '',
                            text: '',
                          }
                        ];
                        this.group_c_range = [
                          {
                            from: '',
                            to: '',
                            text: '',
                          }
                        ];
                        this.group_d_range = [
                          {
                            from: '',
                            to: '',
                            text: '',
                          }
                        ];
                        this.group_e_range = [
                          {
                            from: '',
                            to: '',
                            text: '',
                          }
                        ];
                        this.group_f_range = [
                          {
                            from: '',
                            to: '',
                            text: '',
                          }
                        ];
                        this.group_g_range = [
                          {
                            from: '',
                            to: '',
                            text: '',
                          }
                        ];
                        this.group_h_range = [
                          {
                            from: '',
                            to: '',
                            text: '',
                          }
                        ];
                        this.group_i_range = [
                          {
                            from: '',
                            to: '',
                            text: '',
                          }
                        ];
                        this.group_j_range = [
                          {
                            from: '',
                            to: '',
                            text: '',
                          }
                        ];
                        this.group_k_range = [
                          {
                            from: '',
                            to: '',
                            text: '',
                          }
                        ];
                        this.isModalVisible = false;
                        this.$emit('close');
                        this.fetchAssessmentSectionitems();

                     })
                    .catch(error => {
                      if(error.response.data.message == 'Access denied.') {
                        router.push("/forbidden");
                      }
                    });
                  }

                  
              }
            });

           },
            fetchAssessmentSectionitems() {
              this.loading = true;
              if(this.filterFlag) {
                 this.currentPage = 1;
              }
              const params = { _page: this.currentPage }
              if (this.search_keyword) {
                params.title = this.search_keyword
              }
              if (this.search_status) {
                params.status = this.search_status
              }
              if (this.search_scale) {
                params.search_scale = this.search_scale
              }
              if (this.search_user) {
                params.search_user = this.search_user
              }
              if (this.search_date) {
                const dateStr = moment(this.search_date).format('YYYY-MM-DD HH:mm:ss');
                params.search_date = dateStr;
              }
              if (this.sortField) {
                params.sortfield = this.sortField
              }
              if (this.sortBy) {
                params.sortby = this.sortBy
              }
              axios.get('/assessment-section', {
                 params: params
              })
              .then((resp) => {
                  this.loading = false;
                  this.assessment_section_lists = resp.data.data;
                  this.currentPage = resp.data.page;
                  this.rows = resp.data.total_rows;
              })
              .catch(error => {

              });
            },
           getStatus: function(status) {
             var status_val = this.status_options.findIndex(item => item.value === status);
             return this.status_options[status_val].text;
           },
           getScale: function(scale) {
             var scale_val = this.scale_options.findIndex(item => item.value == scale);
             return this.scale_options[scale_val].text;
           },

            toggleDropdown (id) {
              document.getElementById(id).classList.toggle("show");
            },
            hideActionMenu(e) {
              var matches = document.getElementsByClassName('dropdown-content');
              for (var i=0; i<matches.length; i++) {
                var container = document.getElementById('dropdown-container'+ i);
                if (!container.contains(e.target)) {
                     if (document.getElementById('actionDropdown' + i).classList.contains("show")) {
                        document.getElementById('actionDropdown' + i).classList.remove('show');
                     }
                }
              }
            },

          },
          mounted() {
            document.addEventListener('click', this.hideActionMenu);
          },
          beforeDestroy() {
            document.removeEventListener('click', this.hideActionMenu);
          },
          watch: {
            '$route.params.assessment_id'(newId, oldId) {
              this.assessment_id = newId;
            }
         },
         created() {
          this.assessment_id = this.$route.params.assessment_id;
           if((store.state.page_url) && (store.state.page_url === 'Tasklists')) {
             this.selectedComponent = store.state.active_tab;
           }
           var roles = store.state.roles;
           if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
             this.masterAdmin = true;
           }
           if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
             this.admin = true;
           }
           if(this.$store.state.assessment_section_obj) {
            this.assessment_section_obj = this.$store.state.assessment_section_obj;
           }

           this.fetchUserOptions();
           this.fetchAssessmentSectionitems();
         }
    }
</script>

<style scoped>
.dropdown {
  position: absolute;
  display: inline-block;
  right: 1.4em;
}
.edit-action-btn {
  width: 70px;
  margin-right: 5px;
}
.deactivate-btn {
  width: 83px;
  margin-right: 5px;
}
.preview-wrapper {
  padding-right: 10px;
}
.btn-dark-grey, .btn-dark-grey:hover, .btn-dark-grey:focus {
  background-color: #555;
  color: #FFF;
  border: 1px solid #555;
}
.space-wrapper {
  padding-right: 10px;
}
.tasks_heading_row {
  background-color: #8b8b8b;
  line-height: 30px;
  color: #FFF;
  padding: 3px 0px;
  margin-bottom: 0px;
  margin-right: 0px;
  margin-left: 0px;
}

.tasklist-item {
    padding: 12px 0px 12px 0px;
}
hr {
    border-top: 2px solid #8b8b8b;
    margin: 0px;
}
.no-assessment-text {
  font-size: 20px;
  color: #8b8b8b;
}
.mx-datepicker {
  width: 100%;
}
.custom-select {
  height: 35px;
}
</style>
<style>
.input-height-30 {
  line-height: 28px;
}
.heading-row {
  font-weight: bold;
  color: #000;
  padding-bottom: 5px;
  border-bottom: 2px solid #CCC;
  width: 100%;
  float: left;
}
.add-statement-heading {
  font-weight: bold;
  color: #000;
  font-size: 16px;
  padding: 10px 0 10px 0;
}
.notes_textarea {
  height: 70px !important;
  resize: none;
}
.add-on {
  font-weight: normal;
  font-size: 12px;
  color: #D0D0D0;
  cursor: pointer;
}
.collapse-wrapper {
  background-color: #EEEEEE;
  border: 1px solid #D0D0D0;
  font-weight: bold;
  padding: 5px 10px;
}
.collapse-wrapper a, .collapse-wrapper a:hover{ 
  color: #000;
  text-decoration: none;
}
.collapse-wrapper i {
  float: right;
  font-size: 18px;
  font-weight: bold;
  padding-top: 2px;
  color: #CBCBCB;
}
.ql-editor { min-height: 82px !important;}
</style>



// WEBPACK FOOTER //
// src/components/admin/assessment_section_list.vue